<template>
	<!-- 客户管理 -->
		<div class="saleCustomerManagement sales-preferential-page">
		<div class="public_Spacing customerManagementPC">
			<div class="preferential-page-header">
				<div>
					<div class="preferential-page-title">大客户优惠设置</div>
					<div class="preferential-page-subtitle">快速查看客户优惠、维护等级优惠和额外优惠规则</div>
				</div>
				<div class="preferential-page-actions">
					<el-button class="preferential-primary-action" type="primary" @click="tableDetilsClick">
						<i class="iconfont icon-tianjia1"></i> 优惠设置
					</el-button>
				</div>
			</div>
			<div class="preferential-quick-panel">
				<div class="preferential-stat-card">
					<div class="preferential-stat-label">客户总数</div>
					<div class="preferential-stat-value">{{ count || 0 }}</div>
				</div>
				<div class="preferential-stat-card">
					<div class="preferential-stat-label">当前页客户</div>
					<div class="preferential-stat-value">{{ tableData.length }}</div>
				</div>
				<div class="preferential-stat-card preferential-stat-card-wide">
					<div class="preferential-stat-label">快捷操作</div>
					<div class="preferential-shortcuts">
						<span>筛选客户</span>
						<span>查看优惠</span>
						<span>维护设置</span>
					</div>
				</div>
			</div>
			<div class="pulbic_oparetionBlock preferential-filter-card">
				<div class="public_criteriaRange customerManagementPC-select preferential-filter-fields">
					<div class="public_oparetionBlock_Menu preferential-filter-item">
						<label class="public_lbSty">客户名称：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="cusQueryName" placeholder="请选择客户名称" filterable clearable remote :remote-method="filterCustomerQuery" @keyup.enter.native="querycusList()">
							<el-option v-for="item in filteredCustomerOptionsAll" :key="item.ORMTB410ID" :label="item.ORMTB410CA00" :value="item.ORMTB410CA00">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="customerManagementPC-btn public_operatBtn preferential-filter-actions" style="margin-left: 0px;">
					<el-button class="preferential-reset-btn" type="info" plain @click="resetCustomerQuery">
						清空筛选
					</el-button>
					<el-button class="public_saleWater_chaxun preferential-query-btn" type="primary" v-shiroHiden="solelist" id="查询" @click="querycusList()">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
				</div>
			</div>
			<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container preferential-table-card">
				<div class="preferential-table-toolbar">
					<div>
						<div class="preferential-section-title">客户优惠列表</div>
						<div class="preferential-section-subtitle">点击“查看优惠”可直接查看该客户当前优惠明细</div>
					</div>
					<div class="preferential-table-total">共 {{ count || 0 }} 条</div>
				</div>
				<el-table :data="tableData" height="540" style="width: 100%" stripe class="public_tableColumn preferential-main-table" :header-cell-style="{
					color: 'rgba(51,51,51,1)',
					background: 'rgba(184,227,255,1)',
					'font-weight': 'bold',
				}">
					<el-table-column prop="ORMTB410CA00" label="客户名称" min-width="220">
						<template slot-scope="scope">
							<div class="preferential-customer-cell">
								<div class="preferential-customer-avatar">{{ getCustomerInitial(scope.row.ORMTB410CA00) }}</div>
								<div class="preferential-customer-info">
									<div class="preferential-customer-name">{{ scope.row.ORMTB410CA00 || '--' }}</div>
									<div class="preferential-customer-tip">可查看优惠明细</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="ORMTB410CA06" label="客户等级" min-width="140">
						<template slot-scope="scope">
							<span class="preferential-level-tag">{{ scope.row.ORMTB410CA06Name || '未设置' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="180" fixed="right">
						<template slot-scope="scope">
							<el-button type="primary" class="preferential-view-btn" size="small" @click="viewClick(scope.row)">查看优惠</el-button>
						</template>
					</el-table-column>
					<template slot="empty">
						<div class="preferential-empty">
							<div class="preferential-empty-title">暂无客户优惠数据</div>
							<div class="preferential-empty-desc">可更换客户名称后重新查询</div>
						</div>
					</template>
				</el-table>
				<div class="customerManagementPC-page preferential-page-footer">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40, 100, 200]" layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>

			<div class="public-dialog">
				<el-dialog title="优惠设置" :visible.sync="levelmangShow" @close="" width="78%" top="5vh"
					custom-class="preferential-setting-dialog" :closeOnClickModal='false' append-to-body>
					<div class="preferential-setting-body">
						<div class="levelmang-title preferential-tabs">
						<div class="levelmang_btn" @click="selectTab(item.value)" v-for="item in tabList"
							:key="item.value" :class="tabIndex == item.value ? 'levelmang-title-active' : ''">{{
								item.name }}</div>
					</div>
					<!-- 等级优惠设置 -->
					<div v-if="tabIndex == 1" :key="'grade-' + tabIndex">
						<div class="public_criteriaRange">
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">企业：</label>
								<el-select class="public_optionSty dropDown_Define" v-model="enterpriseTwo"
									 placeholder="请选择" filterable clearable remote :remote-method="filterEnterprise">
									<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select>
							</div>
							<el-button class="public_saleWater_chaxun" type="primary" id="查询"
								@click="queryGradePreLsit">查询</el-button>
						</div>
						<ul class="levelmang-table">
							<li class="levelmang-table-head">
								<div class="levelmang-table-CQ">
									厂区名称
								</div>
								<div class="levelmang-table-JB">
									级别
								</div>
								<div class="levelmang-table-KJ">
									单价扣减
								</div>
								<div class="levelmang-table-ZK">
									整车折扣
								</div>
								<div class="levelmang-table-YH">
									整车优惠
								</div>
							</li>
							<li class="levelmang-table-li" v-for="(item, index) in tableDataGradePre" :key="index">
								<div class="levelmang-table-CQ levelmang-table-CQ-list">
									<div>{{ item.SETTB99CA00 }}</div>
								</div>
								<div class="levelmang-table-li-tab">
									<div class="levelmang-table-li-tab-li" v-for="(items, indexs) in item.settb400List"
										:key="indexs">
										<div class="levelmang-table-JB">
											{{ items.SETTB400CA05Name }}
										</div>
										<div class="levelmang-table-KJ public-chech-details">
											<el-input-number :precision="2" :step="1"
												:class="items.djkj < 0 ? 'djkj-input-negative' : 'djkj-input-positive'"
												v-model="items.djkj"></el-input-number>元
										</div>
										<div class="levelmang-table-ZK">
											<input type="text" v-model="items.zczk" />%
										</div>
										<div class="levelmang-table-YH">
											<input type="text" v-model="items.zcyh" />元
										</div>
									</div>
								</div>
							</li>
						</ul>
						<div class="salesPreferentialDig-btn">
							<el-button type="warning" @click="ResetGradePre">重置</el-button>
							<!-- @click="submissionGradePre" -->
							<el-button type="primary" @click="submisyhsionGradePre">提交</el-button>
						</div>
					</div>
					<!-- 额外优惠设置(新增接口) -->
					<div v-if="tabIndex == 2" :key="'extra-' + tabIndex">
						<div class="public_criteriaRange">
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">客户名称：</label>
								<el-select class="public_optionSty dropDown_Define" v-model="cusQueryNameExtra"
									placeholder="请选择" filterable remote :remote-method="filterCustomer" clearable>
									<el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select>
							</div>
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">企业名称：</label>
								<el-select class="public_optionSty dropDown_Define" v-model="enterpriseTwoExtra"
											placeholder="请选择" filterable clearable remote :remote-method="filterEnterprise">
									<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select>
							</div>
							<el-button class="public_saleWater_chaxun" type="primary" id="查询"
								@click="querycusListExtra">查询</el-button>
							<el-button class="public_saleWater_chaxun public_saleWater_xinzeng"
						type="warning" id="添加额外优惠"
						@click="addDiscounts">添加额外优惠</el-button>
						</div>
						<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
							<el-table :data="tableDataExtra" height="580" style="width: 100%" stripe
								class="public_tableColumn" :header-cell-style="{
									color: 'rgba(51,51,51,1)',
									background: 'rgba(184,227,255,1)',
									'font-weight': 'bold',
								}">
								<el-table-column prop="SETTB414CA08" label="客户名称"></el-table-column>
								<el-table-column prop="SETTB414CA02" label="企业名称"></el-table-column>
								<el-table-column prop="SETTB414CA03" label="单价扣减(元)"></el-table-column>
								<el-table-column prop="SETTB414CA05" label="整车优惠(元)"></el-table-column>
								<el-table-column prop="SETTB414CA04" label="整车折扣(%)"></el-table-column>
								<el-table-column prop="SETTB414CA07" label="是否执行企业账户单个物料优惠">
									<template slot-scope="scope">
										<p>
											<span>{{ scope.row.SETTB414CA07 == 1 ? '否' : '是' }}</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="customerManagementPC-table-btn">
											<el-button type="primary" class="public_icon_xiugai public_icon_width"
												size="small" @click="editExtra(scope.row)">修改
											</el-button>
											<el-button type="primary" class="public_icon_xiugai public_icon_width"
												size="small" @click="deleteExtraList(scope.row)">删除
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="customerManagementPC-page">
								<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
									:current-page.sync="currentPage2" :page-sizes="[10, 20, 30, 40, 100, 200]"
									layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize2"
									:total="count2"></el-pagination>
							</div>
						</div>
					</div>
					<div v-if="tabIndex == 3" :key="'tax-' + tabIndex">
						<div class="public_criteriaRange">
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">客户名称：</label>
								<el-select class="public_optionSty dropDown_Define" v-model="taxObj.ORMTB410ID"
									placeholder="请选择" filterable remote :remote-method="filterCustomer" clearable>
									<el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select>
							</div>
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">企业名称：</label>
								<el-select class="public_optionSty dropDown_Define" v-model="taxObj.SETTB99ID"
									placeholder="请选择" filterable clearable remote :remote-method="filterEnterprise">
									<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select>
							</div>
							<el-button class="public_saleWater_chaxun" type="primary" id="查询"
								@click="querycusListTax">查询</el-button>
							<el-button class="public_saleWater_chaxun public_saleWater_xinzeng"
								style="border-color: rgba(253, 183, 37, 1);" type="primary" id="新增"
								@click="addTaxlist">新增</el-button>
						</div>
						<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
							<el-table :data="tableDataTax" height="580" style="width: 100%" stripe
								class="public_tableColumn" :header-cell-style="{
									color: 'rgba(51,51,51,1)',
									background: 'rgba(184,227,255,1)',
									'font-weight': 'bold',
								}">
								<el-table-column prop="ORMTB703CA01" label="客户名称"></el-table-column>
								<el-table-column prop="ORMTB703CA03" label="企业名称"></el-table-column>
								<el-table-column prop="" label="物料信息">
									<template slot-scope="scope">
										<el-button type="primary" class="public_icon_xiugai public_icon_width"
											size="small" @click="materialTax(scope.row)">物料列表
										</el-button>
									</template>
								</el-table-column>
								<el-table-column prop="" label="状态">
									<template slot-scope="scope">
										<span>已开启含税价</span>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<el-button type="primary" class="public_icon_xiugai public_icon_width"
											size="small" @click="taxClose(scope.row)">关闭
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="customerManagementPC-page">
								<el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
									:current-page.sync="currentPage3" :page-sizes="[10, 20, 30, 40, 100, 200]"
									layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize3"
									:total="count3"></el-pagination>
							</div>
						</div>
					</div>
					<div v-if="tabIndex == 4" :key="'material-' + tabIndex">
						<div class="public_criteriaRange">
							<el-button class="public_saleWater_chaxun public_saleWater_xinzeng"
								style="border-color: rgba(253, 183, 37, 1);" type="primary" id="新增"
								@click="addMateriallist">新增</el-button>
						</div>
						<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
							<el-table :data="tableDataMaterial" height="580" style="width: 100%" stripe
								class="public_tableColumn" :header-cell-style="{
									color: 'rgba(51,51,51,1)',
									background: 'rgba(184,227,255,1)',
									'font-weight': 'bold',
								}">
								<el-table-column prop="SETTB419CA02" label="企业名称"></el-table-column>
								<el-table-column prop="SETTB419CA04" label="物料"></el-table-column>
								<el-table-column prop="SETTB419CA09" label="等级"></el-table-column>
								<el-table-column prop="SETTB419CA06" label="类型">
									<template slot-scope="scope">
										<span>{{ scope.row.SETTB419CA06 == 1 ? '上涨' : '下调' }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB419CA07" label="金额"></el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<el-button type="primary" class="public_icon_xiugai public_icon_width"
											size="small" @click="materialListDelect(scope.row)">删除
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="customerManagementPC-page">
								<el-pagination @size-change="handleSizeChange4" @current-change="handleCurrentChange4"
									:current-page.sync="currentPage4" :page-sizes="[10, 20, 30, 40, 100, 200]"
									layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize4"
									:total="count4"></el-pagination>
							</div>
						</div>
					</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="优惠信息" @close="pageMo = 1, limitMo = 10" :visible.sync="yhPreferentialShow" width="74%"
					custom-class="preferential-info-dialog" top="6vh" :closeOnClickModal='false' append-to-body>
					<div class="preferential-setting-body preferential-info-body">
						<ul class="levelmang-table">
							<li class="levelmang-table-head">
								<div class="levelmang-table-CQ">
									厂区名称
								</div>
								<div class="levelmang-table-JB">
									级别
								</div>
								<div class="levelmang-table-KJ">
									优惠单价
								</div>
								<div class="levelmang-table-ZK">
									整车折扣
								</div>
								<div class="levelmang-table-YH">
									整车优惠
								</div>
							</li>
							<li class="levelmang-table-li" v-for="(item, index) in tableDatayhGradePre" :key="index">
								<div class="levelmang-table-CQ levelmang-table-CQ-list">
									<div>{{ item.name }}</div>
								</div>
								<div class="levelmang-table-li-tab">
									<!-- v-for="(items,indexs) in tableDatayhGradePre" :key="indexs" -->
									<div class="levelmang-table-li-tab-li">
										<div class="levelmang-table-JB">
											{{ item.SETTB400CA05Name }}
										</div>
										<div class="levelmang-table-KJ public-chech-details">
											<div>{{ item.djkj }}</div>

										</div>
										<div class="levelmang-table-ZK">
											<div>{{ item.zczk }}%</div>
										</div>
										<div class="levelmang-table-YH">
											<div>{{ item.zcyh }}元</div>
										</div>
									</div>
								</div>
							</li>
						</ul>

						<div class="salesPreferentialDig-btn">
							<el-button type="primary" @click="submissionGradePre">确定保存</el-button>
							<el-button type="warning" @click="yhPreferentialShow = false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 添加额外优惠弹窗 -->
			<div class="public-dialog">
				<el-dialog :title="editFlag ? '添加额外优惠' : '修改额外优惠'" :visible.sync="discountsFlag" width="88%" top="4vh"
					custom-class="preferential-extra-dialog" @close="" :closeOnClickModal="false" append-to-body>
					<div class="preferential-setting-body preferential-extra-body">
						<div class="preferential-extra-actions">
							<el-button v-if="editFlag" type="primary" @click="addNewRow">添加</el-button>
						</div>
						<el-table class="public_tableColumn" ref="multipleTable" :data="tableDatayh" tooltip-effect="dark"
						:header-cell-style="{
							color: 'rgba(51,51,51,1)',
							background: 'rgba(184,227,255,1)',
							'font-weight': 'bold',
						}" height="560" style="width: 100%">
						<el-table-column label="客户名称" min-width="160">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB414CA00" placeholder="请选择客户名称" filterable
									remote :remote-method="filterCustomerQuery" style="width:100%" clearable
									@change="getLevelName(scope.$index)" :disabled="!editFlag">
									<el-option v-for="item in filteredCustomerOptionsAll" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="企业名称" min-width="160">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB414CA02" placeholder="请选择企业名称"
									@change="getLevelProduct(scope.$index)" filterable style="width:100%" clearable remote :remote-method="filterEnterprise"
									:disabled="!editFlag || !scope.row.SETTB414CA00"
									@focus="!scope.row.SETTB414CA00 && $message.warning('请先选择客户')">
									<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99CA00">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="djkj" label="等级单价优惠"></el-table-column>
						<el-table-column prop="zcyh" label="等级整车优惠"></el-table-column>
						<el-table-column prop="zczk" label="等级整车折扣"></el-table-column>
						<el-table-column prop="SETTB414CA03" label="单价扣减(元)">
							<template slot-scope="scope">
								<el-input v-model="scope.row.SETTB414CA03" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB414CA05" label="整车优惠(元)">
							<template slot-scope="scope">
								<el-input v-model="scope.row.SETTB414CA05" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB414CA04" label="整车折扣(%)">
							<template slot-scope="scope">
								<el-input v-model="scope.row.SETTB414CA04" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB414CA07" width="240" label="是否享受统一单个物料优惠">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB414CA07" @change="dgwlyhFun" placeholder="请选择">
									<el-option v-for="item in dgwlyhOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB414CA07" label="物料信息">
							<template slot-scope="scope">
								<el-button v-if="scope.row.SETTB414CA07 == '1'" type="primary"
									class="public_icon_xiugai public_icon_width" size="small"
									@click="slmsgClick(scope.row)">物料信息
								</el-button>
							</template>
						</el-table-column>
						<el-table-column label="操作" v-if="editFlag">
							<template slot-scope="scope">
								<el-button type="primary" class="public_icon_xiugai public_icon_width" size="small"
									@click="deleteRow(scope.$index)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="salesPreferentialDig-btn">
						<el-button type="warning" @click="khyhqx()">取消</el-button>
						<el-button type="primary" @click="khyhserve()">提交</el-button>
					</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="物料信息" :visible.sync="materShow" width="70%" :closeOnClickModal="false" append-to-body custom-class="sales-preferential-dialog">
					<div class="public-chech systemCorporateAccount-dialog">
						<div class="public-chech-details">
							<div class="public-chech-details-tile">
								<div class="public-chech-details-tile-pre">物料类型：</div>
								<el-select v-model="categoryMaterial">
									<el-option v-for="item in materialTypeList" :key="item.SETTB206CA00"
										:label="item.SETTB206CA01" :value="item.SETTB206CA00">
									</el-option>
								</el-select>
								<div class="public-chech-details-tile-q">物料名称：</div>
								<div class="public-chech-details-tile-q-sel systemCorporateAccount-wuliao-input">
									<el-input type="text" v-model="nameMaterial" placeholder="请输入"></el-input>
								</div>
								<el-button type="primary" style="margin-left: 20px;" @click="MaterialQuery">查询
								</el-button>
							</div>
							<div class="pulbic_oparetionBlock pulbic_table_container">
								<el-table :data="materList" style="width: 100%" stripe max-height="90%"
									class="public_tableColumn" :header-cell-style="{
										color: 'rgba(51,51,51,1)',
										'font-weight': 'bold',
									}" @filter-change="handleMaterialTypeFilter">
									<el-table-column align="center" prop="SETTB99CA00" label="企业名称"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA00" label="物料名称"></el-table-column>
									<el-table-column align="center" prop="SETTB206CA01" label="物料类型"
										column-key="SETTB206CA01"
										:filters="materialTypeFilters"
										:filter-multiple="false"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA01_ys"
										label="零售价格"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA01" label="优惠价格"></el-table-column>
									<!-- <el-table-column align="center" prop="SETTB109CA02" label="状态"></el-table-column> -->
									<!-- <el-table-column align="center" prop="SETTB109CA05" label="计量单位"></el-table-column> -->
									<!-- <el-table-column align="center" prop="SETTB109CB06" label="高度">
										<template slot-scope="scope">
											<span v-if="scope.row.SETTB109CB06">{{scope.row.SETTB109CB06}}</span>
											<span v-else>暂无数据</span>
										</template>

									</el-table-column>
									 -->
									<el-table-column align="center" label="操作" width="260">
										<template slot-scope="scope">
											<el-button class="public_icon_xiugai public_icon_width" type="info"
												size="small" @click="DiscountModify(scope.row)" id="优惠调控">
												优惠调控
											</el-button>
										</template>
									</el-table-column>
								</el-table>
								<div class="pulbic_pagesize">
									<el-pagination @size-change="handleSizeChangeMaterial"
										@current-change="handleCurrentChangeMaterial"
										:current-page.sync="currentPageMaterial" :page-sizes="[10, 20, 30, 40]"
										:page-size="limitMaterial" layout="total,sizes, prev, pager, next, jumper"
										:total="pagingPageMaterial"></el-pagination>
								</div>
							</div>
						</div>
						<!-- <div class="public-dialog-btn">
							<el-button type="primary" @click="">保存</el-button>
							<el-button type="warning" @click="materShow=false">取消</el-button>
						</div> -->
					</div>
				</el-dialog>
			</div>

			<div class="public-dialog">
				<el-dialog title="优惠调控" :visible.sync="discountShow" width="25%"
					@close="discountShow = false; floatingType == ''" :closeOnClickModal="false" append-to-body custom-class="sales-preferential-dialog">
					<div class="systemCorporateAccount-dialog">
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">用户名称<span>*</span></div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="userName" placeholder="请输入" readonly />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">企业名称<span>*</span></div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="enterNameMaterialModify"
									placeholder="请输入" readonly />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">物料名称<span>*</span></div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="nameMaterialModify"
									placeholder="请输入" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">上次单个物料优惠</div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="individualDiscount"
									placeholder="请输入" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">当前价格</div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="currentPrice" placeholder="请输入" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">浮动类型<span>*</span></div>
							<div class="SCADL-input">
								<el-radio v-model="floatingType" size="medium" label="1"
									@input="floatingTypeInput">上浮</el-radio>
								<el-radio v-model="floatingType" size="medium" label="2"
									@input="floatingTypeInput">下调</el-radio>
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">浮动金额<span>*</span></div>
							<div class="SCADL-input levelmang-table-KJ public-chech-details">
								<el-input-number class="num" style="text-align: center; font-size: 18px !important;"
									:precision="2" :step="1" :min="0" :max="100" v-model="floatingAmount"
									@input="floatingAmountInput">
								</el-input-number>元
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">调整后价格</div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="adjustedPrice" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-btn">
							<el-button type="primary" @click="preservationDiscountModify">保存</el-button>
							<el-button type="warning" @click="discountShow = false; floatingType == ''">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 含税设置新增 -->
			<div class="public-dialog">
				<el-dialog title="含税设置新增" :visible.sync="taxFlag" width="70%" @close="" :closeOnClickModal="false" append-to-body custom-class="sales-preferential-dialog">
					<el-button type="primary" @click="addTax" style="margin-bottom: 10px;">添加</el-button>
					<el-table class="public_tableColumn" ref="multipleTableTax" :data="tableDataTaxAdd"
						tooltip-effect="dark" :header-cell-style="{
							color: 'rgba(51,51,51,1)',
							background: 'rgba(184,227,255,1)',
							'font-weight': 'bold',
						}" height="700" style="width: 100%">
						<el-table-column prop="ORMTB703CA00" label="客户名称">
							<template slot-scope="scope">
								<el-select v-model="scope.row.ORMTB703CA00"
									@change="taxPreferentialChange(scope.$index)" placeholder="请选择" filterable clearable
									remote :remote-method="filterCustomerQuery">
									<el-option v-for="item in filteredCustomerOptionsAll" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="ORMTB703CA02" label="企业名称">
							<template slot-scope="scope">
								<el-select v-model="scope.row.ORMTB703CA02" placeholder="请选择" filterable clearable
									remote :remote-method="filterEnterprise"
									:disabled="!scope.row.ORMTB703CA00"
									@focus="!scope.row.ORMTB703CA00 && $message.warning('请先选择客户')">
									<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button type="primary" class="public_icon_xiugai public_icon_width" size="small"
									@click="deleteTax(scope.$index)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="salesPreferentialDig-btn">
						<el-button type="primary" @click="taxSave">提交</el-button>
						<el-button type="warning" @click="taxFlag = false">取消</el-button>
					</div>
				</el-dialog>
			</div>
			<!-- 含税价设置物料信息列表 -->
			<div class="public-dialog">
				<el-dialog title="物料列表" :visible.sync="hanshuijiaShow" width="70%" :closeOnClickModal="false" @close="" append-to-body custom-class="sales-preferential-dialog">
					<div class="public-chech systemCorporateAccount-dialog">
						<div class="public-chech-details">
							<div class="pulbic_oparetionBlock pulbic_table_container">
								<el-table :data="fdmaterList" style="width: 100%" stripe max-height="90%"
									class="public_tableColumn" :header-cell-style="{
										color: 'rgba(51,51,51,1)',
										'font-weight': 'bold',
									}">
									<el-table-column align="center" prop="SETTB99CA00" label="企业名称"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA00" label="物料名称"></el-table-column>
									<!-- <el-table-column align="center" prop="SETTB206CA01" label="物料类型"></el-table-column> -->
									<el-table-column align="center" prop="SETTB109CA01_ys"
										label="零售价格"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA01" label="不含税价格"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA01_hs"
										label="含税价格"></el-table-column>
									<!-- <el-table-column align="center" prop="SETTB420CA10"
										:label="labeText"></el-table-column> -->

									<!-- <el-table-column align="center" label="操作" width="260">
										<template slot-scope="scope">

											<el-button class="public_icon_xiugai public_icon_width" type="info"
												size="small" @click="deleteFd(scope.row)" id="删除">
												删除
											</el-button>
										</template>
									</el-table-column> -->
								</el-table>
								<div class="pulbic_pagesize">
									<el-pagination @size-change="hsjhandleSizeChangeMaterial"
										@current-change="hsjhandleCurrentChangeMaterial"
										:current-page.sync="hsjListpageMaterial" :page-sizes="[10, 20, 30, 40]"
										:page-size="hsjListlimitMaterial" layout="total,sizes, prev, pager, next, jumper"
										:total="hsjListpagingPageMaterial"></el-pagination>
								</div>
								<!-- <div class="systemCorporateAccount-dialog-btn" style="margin-top: 20px">
									<el-button type="primary" @click="hsjyhserve()">提交</el-button>
									<el-button type="warning" @click="hsjszCloFun()">取消</el-button>
								</div> -->
							</div>
						</div>
						<!-- <div class="public-dialog-btn">
	                <el-button type="primary" @click="">保存</el-button>
	                <el-button type="warning" @click="materShow=false">取消</el-button>
	              </div> -->
					</div>
				</el-dialog>
			</div>
			<!-- 物料等级设置新增 -->
			<div class="public-dialog">
				<el-dialog title="物料等级设置新增" :visible.sync="materialFlag" width="70%" @close=""
					:closeOnClickModal="false" append-to-body custom-class="sales-preferential-dialog">
					<el-button type="primary" @click="addMaterial" style="margin-bottom: 10px">添加</el-button>
					<el-table class="public_tableColumn" ref="multipleTableMaterial" :data="tableDataMaterialAdd"
						tooltip-effect="dark" :header-cell-style="{
							color: 'rgba(51,51,51,1)',
							background: 'rgba(184,227,255,1)',
							'font-weight': 'bold',
						}" height="700" style="width: 100%">
						<el-table-column prop="SETTB419CA01" label="企业名称">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB419CA01" @change="erpChange(scope.$index)"
									placeholder="请选择" filterable clearable remote :remote-method="filterEnterprise">
									<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB419CA03" label="物料">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB419CA03" placeholder="请选择"
									@change="materielAddChange(scope.$index)">
									<el-option v-for="item in materielOptions" :key="item.SETTB109ID"
										:label="item.SETTB109CA00" :value="item.SETTB109ID">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB419CA00" label="等级">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB419CA00" placeholder="请选择">
									<el-option v-for="item in khdjOperation" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB419CA06" label="类型">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB419CA06" @change="typeAddChange(scope.$index)"
									placeholder="请选择">
									<el-option v-for="item in adjustmentType" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB419CA07" label="金额">
							<template slot-scope="scope">
								<el-input type="text" v-model="scope.row.SETTB419CA07"
									@input="moneyAddInput(scope.$index)" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="money" label="调整后优惠金额">
							<template slot-scope="scope">
								<span>{{ scope.row.money }}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button type="primary" class="public_icon_xiugai public_icon_width" size="small"
									@click="deleteMaterial(scope.$index)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="salesPreferentialDig-btn">
						<el-button type="primary" @click="materialSave">提交</el-button>
						<el-button type="warning" @click="materialFlag = false">取消</el-button>
					</div>
				</el-dialog>
			</div>
				<!-- 查看 -->
				<div class="public-dialog">
					<el-dialog :title="viewTitle" :visible.sync="viewFlag" width="92%" top="4vh"
						custom-class="view-preferential-dialog" @close="resetViewDialog" :closeOnClickModal="false" append-to-body>
						<div class="view-preferential-body">
							<div class="view-preferential-summary">
								<div>
									<div class="view-preferential-title">{{ viewTitle || '优惠信息' }}</div>
									<div class="view-preferential-subtitle">按企业与物料快速筛选，查看等级、额外、物料和含税优惠明细</div>
								</div>
								<div class="view-preferential-count">
									<span>当前结果</span>
									<strong>{{ tableDataView.length }}</strong>
								</div>
							</div>
							<div class="view-preferential-filter">
								<div class="view-filter-item">
									<label>企业名称：</label>
									<el-select class="view-filter-select" v-model="taxViewObj.SETTB99ID" placeholder="请选择企业"
										@change="enterpriseChange" filterable clearable remote :remote-method="filterEnterprise">
										<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
											:label="item.SETTB99CA00" :value="item.SETTB99ID">
										</el-option>
									</el-select>
								</div>
								<div class="view-filter-item">
									<label>物料：</label>
									<el-select class="view-filter-select" v-model="taxViewObj.SETTB109ID" placeholder="请选择物料" clearable filterable
										:disabled="!taxViewObj.SETTB99ID"
										@focus="!taxViewObj.SETTB99ID && $message.warning('请先选择企业')">
										<el-option v-for="item in viewMaterialTypeList" :key="item.SETTB109ID"
											:label="item.SETTB109CA00" :value="item.SETTB109ID">
										</el-option>
									</el-select>
								</div>
								<div class="view-filter-actions">
									<el-button class="view-reset-btn" type="info" plain @click="resetViewFilter">重置</el-button>
									<el-button class="view-query-btn" type="primary" id="查询" @click="viewQuery">查询</el-button>
								</div>
							</div>
							<div class="view-preferential-table-card">
								<div class="view-table-toolbar">
									<div>
										<div class="view-table-title">优惠明细</div>
										<div class="view-table-subtitle">固定企业、物料和价格列，横向查看更多优惠维度</div>
									</div>
									<div class="view-table-total">共 {{ tableDataView.length }} 条</div>
								</div>
								<el-table :data="pagedTableDataView" height="500" style="width: 100%" stripe
									class="public_tableColumn view-preferential-table" :header-cell-style="{
										color: 'rgba(51,51,51,1)',
										background: 'rgba(184,227,255,1)',
										'font-weight': 'bold',
									}">
									<el-table-column prop="qymc" label="企业名称" min-width="150" fixed show-overflow-tooltip></el-table-column>
									<el-table-column prop="wlmc" label="物料" min-width="150" fixed show-overflow-tooltip></el-table-column>
									<el-table-column prop="lsj" label="零售价" min-width="100" fixed show-overflow-tooltip></el-table-column>
									<el-table-column prop="djyh_dj" label="单价优惠(等级)" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="zczk_dj" label="整车折扣(等级)" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="zcyh_dj" label="整车优惠(等级)" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="yhtk_dj" label="优惠调控(等级)" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="djyh_ew" label="单价优惠(额外)" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="zczk_ew" label="整车折扣(额外)" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="zcyh_ew" label="整车优惠(额外)" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="yhtk_ew" label="优惠调控(额外)" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="wldjyh" label="物料等级优惠" min-width="130" show-overflow-tooltip></el-table-column>
									<el-table-column prop="ssjg" label="实时价格" min-width="110" show-overflow-tooltip></el-table-column>
									<el-table-column prop="hsjg" label="含税价格" min-width="110" show-overflow-tooltip></el-table-column>
									<template slot="empty">
										<div class="view-preferential-empty">
											<div>暂无优惠明细</div>
											<span>请选择企业或物料后点击查询</span>
										</div>
									</template>
								</el-table>
								<div class="view-preferential-pagination">
									<el-pagination @size-change="handleViewSizeChange" @current-change="handleViewCurrentChange"
										:current-page.sync="viewCurrentPage" :page-sizes="[10, 20, 30, 50]"
										layout="total, sizes, prev, pager, next, jumper" :page-size="viewPageSize"
										:total="tableDataView.length"></el-pagination>
								</div>
							</div>
						</div>
					</el-dialog>
				</div>
		</div>
	</div>
</template>
<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
	data() {
		return {
			uobj: this.$store.state.uobj, //登陆缓存--用户信息
			cusQueryName: '',
			tableData: [],
			count: 0,
			pagesize: 10,
			page: 1,
			currentPage: 1,
			tableDataExtra: [],
			count2: 0,
			pagesize2: 10,
			page2: 1,
			currentPage2: 1,
			count3: 0,
			pagesize3: 10,
			page3: 1,
			currentPage3: 1,
			count4: 0,
			pagesize4: 10,
			page4: 1,
			currentPage4: 1,
			levelmangShow: false,
			tableDataGradePre: [],
			enterpriseTwo: '',
			// enterpriseTwoOptionList: [],
			settb400List: [],
			tableDatayhGradePre: [],
			yhPreferentialShow: false,
			pageMo: 1, //默认列表页码
			limitMo: 10, //每页的条数
			tabIndex: 1,
			tabList: [
				{
					name: '等级优惠设置',
					value: 1
				},
				{
					name: '额外优惠设置',
					value: 2
				},
				{
					name: '含税价设置',
					value: 3
				},
				{
					name: '物料等级设置',
					value: 4
				},
			],
			discountsFlag: false,//添加额外优惠设置弹窗	
			tableDatayh: [
				{
					id: 1,
					SETTB414CA00: '',
					SETTB414CA01: '',
					SETTB414CA02: '',
					SETTB414CA03: '',
					SETTB414CA04: '',
					SETTB414CA05: '',
					SETTB414CA07: 1,
					SETTB414CA08: '',
					djkj: '',
					zcyh: '',
					zczk: ''
				}
			],
			tableDataTaxAdd: [
				{
					id: 1,
					ORMTB703CA00: "",
					ORMTB703CA01: "",
					ORMTB703CA02: "",
					ORMTB703CA04: 1,
				}
			],
			tableDataMaterialAdd: [{
				id: 1,
				SETTB419CA01: "",
				SETTB419CA02: "",
				SETTB419CA03: "",
				SETTB419CA04: "",
				SETTB419CA00: "",
				SETTB419CA06: "",
				SETTB419CA07: "",
				money: "",
			}],
			// 物料信息
			materShow: false,
			materList: [],
			materiaShowZJ: '', //判断是否显示新增，修改，禁用按钮
			categoryMaterial: '', //物料类别
			nameMaterial: '', //物料名称
			pageMaterial: 1, //默认列表页码
			limitMaterial: 10, //每页的条数
			pagingPageMaterial: 0, //分页--数据列表共有的条数
			currentPageMaterial: 1, //设置当前页默认为1
			materialTypeList: [],
			cjmsgobj: {},

			//优惠调控
			discountShow: false,
			floatingType: '', //浮动类型-上浮-下浮
			floatingAmount: 0, //浮动金额
			disabled: true,

			useryhmsg: {},

			enterNameMaterialModify: '', //企业名称
			nameMaterialModify: '', //物料名称
			wholesalePriceModify: '', //零售价格
			preferentialType: 0,
			solelist: [],
			cusUDJSetpdateShow: false,
			tableDataGradePre: [],
			innerVisible: false,
			dgwlyh: '',
			dgwlyhOptions: [
				{
					value: 0,
					label: '是',
				},
				{
					value: 1,
					label: '否',
				},
			],
			nextId: 2,
			tableDataTax: [],
			enterpriseTwoOptionList: [
				{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				},
			],
			enterpriseTwoOptionListAll: [],
			filteredCustomerOptionsAll: [],
			taxFlag: false,
			taxId: 2,
			hanshuijiaShow: false,
			hsjList: [],
			hsjListpageMaterial: 1, //默认列表页码
			hsjListlimitMaterial: 10, //每页的条数
			hsjListpagingPageMaterial: 0, //分页--数据列表共有的条数
			hsjcurrentPageMaterial: 1, //设置当前页默认为1
			fdmaterList: [],
			taxObj: {
				SETTB99ID: '',
				ORMTB410ID: ''
			},
			taxViewObj: {
				SETTB99ID: '',
				SETTB109ID: ''
			},
			tableDataMaterial: [],
			materialFlag: false,
			materialId: 2,
			viewFlag: false,
			tableDataView: [],
			customerMo: '',
			cusQueryNameExtra: '',//额外优惠设置客户名称
			enterpriseTwoExtra: '',//额外优惠设置企业名称
			extraObj: {},
			editFlag: true,
			materielOptions: [],
			khdjOperation: [
				{
					value: '0301',
					label: '一级客户',
				},
				{
					value: '0302',
					label: '二级客户',
				},
				{
					value: '0303',
					label: '三级客户',
				},
				{
					value: '0304',
					label: '四级客户',
				},
				{
					value: '0305',
					label: '五级客户',
				},
				{
					value: '0306',
					label: '六级客户',
				},
				{
					value: '0307',
					label: '七级客户',
				},
				{
					value: '0308',
					label: '八级客户',
				},
				{
					value: '0309',
					label: '九级客户',
				},
			],
			adjustmentType: [
				{ value: 1, label: '上涨' },
				{ value: 2, label: '下调' }
			],
			nameId: '',
			productId: '',
			MaterialModify109ID: '',
			enterNameMaterialModify: '',
			nameMaterialModify: '',
			userName: '',//优惠调控-用户名称
			individualDiscount: '',//优惠调控-上次单个物料优惠
			currentPrice: 0,//优惠调控-当前价格
			adjustedPrice: '',//优惠调控-调整后价格
			taxProductId: '',
			taxName: '',
			viewMaterialTypeList: [
				{
					SETTB109CA00: '全部',
					SETTB109ID: ''
				}
			],
			viewNameId: '',
			nameTitle: '',
			viewTitle: '',
			viewPageSize: 10,
			viewCurrentPage: 1,
		}
	},
	watch: {
		customerOptionsAll(val) {
			this.filteredCustomerOptionsAll = val.slice(0, 100)
		},
		'currentPrice': function (newVal, oldVal) {
			this.getAdjustedPrice();
		},
		'floatingType': function (newVal, oldVal) {
			this.getAdjustedPrice();
		}
	},
	computed: {
		materialTypeFilters() {
			return this.materialTypeList
				.filter(item => item.SETTB206CA00 !== '')
				.map(item => ({ text: item.SETTB206CA01, value: item.SETTB206CA00 }))
		},
		pagedTableDataView() {
			const start = (this.viewCurrentPage - 1) * this.viewPageSize;
			return this.tableDataView.slice(start, start + this.viewPageSize);
		}
	},
	created() {
		var list = "";
		list = this.$store.state.solelist;
		var path = this.$route.path;
		if (path === "/SalesPreferential") {
			path = "/Home" + path;
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		this.uobj = this.$store.state.uobj;
		// 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
		sessionStorage.removeItem(this.currentUrl);
		if (this.historyInfo != null && this.historyInfo != "") {
			this.init();
		}
	},
	mounted() {
		this.querycusList()
		this.enterprise0ptions();
		this.enterprise2Options();
	},
	methods: {
		enterpriseChange(value) {
			this.taxViewObj.SETTB109ID = '';
			this.viewMaterialTypeList = [
				{
					SETTB109CA00: '全部',
					SETTB109ID: ''
				}
			];
			if (value) {
				this.materielMoPost(value, 1);//查看弹窗调用
			}
		},
		taxClose(row) {
			row.ORMTB703CA04 = 0;
			this.$confirm('此操作将关闭含税价, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = '/orm/ormtb703/changeTaX'
				var postData = [row];
				this.axios
					.post(url, postData)
					.then(res => {
						if (res.data.code == 200) {
							
							this.querycusListTax();
							this.$message({
								message: res.data.message,
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.message,
								type: 'error',
							})
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					})
			}).catch(() => {
				this.$message.info('操作已取消');
			});
		},
		floatingTypeInput() {
			this.getAdjustedPrice();
		},
		floatingAmountInput() {
			this.getAdjustedPrice();
		},
		getAdjustedPrice() {
			var url = '/set/settb109/selectPrice'
			this.axios.post(url, { ORMTB410ID: this.nameId, SETTB109ID: this.MaterialModify109ID, SETTB418CA06: this.floatingType, SETTB418CA07: this.floatingAmount, SETTB418CA10: this.currentPrice }).then(res => {
				if (res.data.code == 200) {
					this.adjustedPrice = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		materialListDelect(row) {
			this.$confirm('此操作将删除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = '/set/settb419/delete'
				this.axios.post(url, { SETTB419ID: row.SETTB419ID }).then(res => {
					if (res.data.code == 200) {
						this.$message.success(res.data.message);
						this.querycusListMetail();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})

			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		materielAddChange(index) {
			const row = this.tableDataMaterialAdd[index];
			const item = this.materielOptions.find(item => item.SETTB109ID === row.SETTB419CA03);
			this.$set(row, 'SETTB419CA04', item.SETTB109CA00);
			this.getMoneyData(row.SETTB419CA03, row.SETTB419CA06, row.SETTB419CA07, row)
		},
		typeAddChange(index) {
			const row = this.tableDataMaterialAdd[index];
			this.getMoneyData(row.SETTB419CA03, row.SETTB419CA06, row.SETTB419CA07, row)
		},
		moneyAddInput(index) {
			const row = this.tableDataMaterialAdd[index];
			this.getMoneyData(row.SETTB419CA03, row.SETTB419CA06, row.SETTB419CA07, row)
		},
		getMoneyData(SETTB419CA03, SETTB419CA06, SETTB419CA07, row) {
			var url = '/set/settb419/selectPrice'
			var data = {
				SETTB419CA03: SETTB419CA03,
				SETTB419CA06: SETTB419CA06,
				SETTB419CA07: SETTB419CA07,
			}
			this.axios.post(url, data).then(res => {
				if (res.data.code == 200) {
					this.$set(row, 'money', JSON.stringify(res.data.data) === '{}' ? '' : res.data.data);
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		erpChange(index) {
			const row = this.tableDataMaterialAdd[index];
			const item = this.enterpriseTwoOptionListAll.find(item => item.SETTB99ID === row.SETTB419CA01);
			this.$set(row, 'SETTB419CA02', item.SETTB99CA00);
			this.materielMoPost(row.SETTB419CA01);
		},
		materielMoPost(id, type) {
			var url = '/set/settb109/selectPageList'
			var data = {
				SETTB99ID: id,
				page: 1,
				limit: 1000,
			}
			let list = [
				{
					SETTB109CA00: '全部',
					SETTB109ID: ''
				}
			]
			this.axios.post(url, data).then(res => {
				if (res.data.code == 200) {
					if (type) {//查看弹窗调用
						this.viewMaterialTypeList = [...list, ...res.data.data];
					} else {
						this.materielOptions = res.data.data;
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		deleteExtraList(row) {
			this.$confirm('此操作将删除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = '/set/settb414/delete'
				this.axios.post(url, { SETTB414ID: row.SETTB414ID }).then(res => {
					if (res.data.code == 200) {
						this.$message.success(res.data.message);
						this.querycusListExtra();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})

			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		// 额外优惠设置修改
		editExtra(row) {
			this.discountsFlag = true;
			this.editFlag = false;
			this.extraObj = row;
			let obj = { ...this.extraObj, id: 1 }
			this.tableDatayh = [obj];
			this.getLevelData(row.SETTB414CA00, row.SETTB414CA01, obj);
		},
		onEnterpriseLoaded(data) {
			this.enterpriseTwoOptionListAll = data
		},
		filterCustomerQuery(query) {
			if (!query) {
				this.filteredCustomerOptionsAll = this.customerOptionsAll.slice(0, 100)
				return
			}
			const q = query.toLowerCase()
			this.filteredCustomerOptionsAll = this.customerOptionsAll.filter(item =>
				(item.ORMTB410CA00 || '').toLowerCase().includes(q) ||
				(item.ORMTB410CA13 || '').toLowerCase().includes(q)
			)
		},
		getLevelName(index) {
			const row = this.tableDatayh[index];
			// 客户变更时清空企业
			this.$set(row, 'SETTB414CA02', '')
			if (!row.SETTB414CA00) {
				this.$set(row, 'SETTB414CA08', '')
				return
			}
			const item = this.customerOptionsAll.find(item => item.ORMTB410ID === row.SETTB414CA00);
			this.$set(row, 'SETTB414CA08', item.ORMTB410CA00);
			this.getLevelData(row.SETTB414CA00, row.SETTB414CA01, row);
		},
		getLevelProduct(index) {
			const row = this.tableDatayh[index];
			if (!row.SETTB414CA02) {
				this.$set(row, 'SETTB414CA01', '')
				this.$set(row, 'djkj', '')
				this.$set(row, 'zcyh', '')
				this.$set(row, 'zczk', '')
				return
			}
			const item = this.enterpriseTwoOptionListAll.find(item => item.SETTB99CA00 === row.SETTB414CA02);
			if (!item) return
			this.$set(row, 'SETTB414CA01', item.SETTB99ID);
			this.getLevelData(row.SETTB414CA00, row.SETTB414CA01, row);
		},
		// 额外优惠设置获取等级优惠
		getLevelData(ORMTB410ID, SETTB99ID, row) {
			var url = '/set/settb414/selectPrice'
			this.axios.post(url, { ORMTB410ID: ORMTB410ID, SETTB99ID: SETTB99ID }).then(res => {
				if (res.data.code == 200) {
					this.$set(row, 'djkj', res.data.data.djkj);
					this.$set(row, 'zcyh', res.data.data.zcyh);
					this.$set(row, 'zczk', res.data.data.zczk);
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		// 查看弹窗
		viewQuery() {
			if (!this.taxViewObj.SETTB99ID) {
				return this.$message({ message: '请先选择企业', type: 'warning' })
			}
			var url = '/set/settb109/selectPreferential'
			var postData = {
				ormtb410Id: this.viewNameId,
				SETTB109ID: this.taxViewObj.SETTB109ID || '',
				SETTB99ID: this.taxViewObj.SETTB99ID,
			};
			this.axios
				.post(url, postData)
				.then(res => {
					if (res.data.code == 200) {
						const data = res.data.data;
						this.tableDataView = Array.isArray(data) ? data : (data ? [data] : []);
						this.viewCurrentPage = 1;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
		},
		//查看按钮
		viewClick(row) {
			this.viewFlag = true;
			this.viewTitle = `${row.ORMTB410CA00}的优惠信息`;
			this.taxViewObj = {
				SETTB99ID: '',
				SETTB109ID: ''
			};
			this.tableDataView = [];
			this.viewNameId = row.ORMTB410ID;
			this.viewCurrentPage = 1;
			this.viewPageSize = 10;
		},
		resetViewFilter() {
			this.taxViewObj.SETTB99ID = '';
			this.taxViewObj.SETTB109ID = '';
			this.tableDataView = [];
			this.viewMaterialTypeList = [
				{
					SETTB109CA00: '全部',
					SETTB109ID: ''
				}
			];
			this.viewCurrentPage = 1;
		},
		resetViewDialog() {
			this.taxViewObj = {
				SETTB99ID: '',
				SETTB109ID: ''
			};
			this.tableDataView = [];
			this.viewNameId = '';
			this.viewCurrentPage = 1;
			this.viewPageSize = 10;
		},
		handleViewSizeChange(val) {
			this.viewPageSize = val;
			this.viewCurrentPage = 1;
		},
		handleViewCurrentChange(val) {
			this.viewCurrentPage = val;
		},
		//含税设置客户名称选择
		taxPreferentialChange(index) {
			const row = this.tableDataTaxAdd[index];
			// 客户变更时清空企业
			this.$set(row, 'ORMTB703CA02', '')
			if (!row.ORMTB703CA00) {
				this.$set(row, 'ORMTB703CA01', '')
				return
			}
			const item = this.customerOptionsAll.find(item => item.ORMTB410ID === row.ORMTB703CA00);
			if (item) this.$set(row, 'ORMTB703CA01', item.ORMTB410CA00);
		},
		//物料等级企业选择
		materialChange() {

		},
		taxSave() {
			if (this.tableDataTaxAdd.length == 0) {
				this.$message({
					message: '请添加数据',
					type: 'warning',
				})
				return
			} else {
				if (this.hasEmptyPropertyValue(this.tableDataTaxAdd)) {
					this.$message({
						message: '请填写完整的数据',
						type: 'warning',
					})
					return
				}
			}
			var url = '/orm/ormtb703/changeTaX'
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = this.tableDataTaxAdd;
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// console.log(res)
						this.taxFlag = false;
						this.querycusListTax();
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'error'
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},
		//物料等级物理删除
		deleteMaterial(index) {
			this.$confirm('此操作将移除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.tableDataMaterialAdd.splice(index, 1);
				this.$message.success('删除成功');
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		//物料优惠新增
		addMateriallist() {
			this.materialFlag = true;
			this.materialId = 1;
			this.tableDataMaterialAdd = [{
				id: 1,
				SETTB419CA01: "",
				SETTB419CA02: "",
				SETTB419CA03: "",
				SETTB419CA04: "",
				SETTB419CA00: "",
				SETTB419CA06: "",
				SETTB419CA07: "",
				money: "",
			}]
		},
		// 物料等级保存
		materialSave() {
			if (this.tableDataMaterialAdd.length == 0) {
				this.$message({
					message: '请添加数据',
					type: 'warning',
				})
				return
			} else {
				if (this.hasEmptyPropertyValue(this.tableDataMaterialAdd)) {
					this.$message({
						message: '请填写完整的数据',
						type: 'warning',
					})
					return
				}
			}
			var url = '/set/settb419/save'
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				list: this.tableDataMaterialAdd,
			}
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// console.log(res)
						this.materialFlag = false;
						this.querycusListMetail();
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'error'
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},
		ykhsjChangJiaFun() {
			//查询已开启含税价厂家
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				ORMTB703CA02: this.taxObj.SETTB99ID,
				ORMTB703CA00: this.taxObj.ORMTB410ID,
				page: this.page3,
				limit: this.pagesize3
			}
			var url = '/orm/ormtb703/selectList'
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.count3 = res.data.data.total;
						this.tableDataTax = res.data.data.list;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		selectwlhxPageListFun() {
			//根据厂家获取物料含税价和不含税价信息
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				SETTB99ID: this.taxProductId,
				ORMTB410ID: this.taxName,
				limit: this.hsjListlimitMaterial,
				page: this.hsjListpageMaterial,
			}
			var fdmoList
			var url = 'set/settb109/selectwlhxPageList'
			this.axios
				.post(url, postData)
				.then(res => {
					console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						fdmoList = res.data.data.list
						this.fdmaterList = fdmoList
						this.hsjListpagingPageMaterial = res.data.count

						// if (res.data.data.taxSwitch == 0) {
						// 	this.hanshuijiaKG = false
						// 	this.hsjstus = 0
						// } else {
						// 	this.hanshuijiaKG = true
						// 	this.hsjstus = 1
						// }
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		// fdPageMaterialList(id) {
		// 	let loading = this.$loading({
		// 		lock: true,
		// 		text: '请求中...',
		// 		spinner: 'el-icon-loading',
		// 		background: 'rgba(0, 0, 0, 0.5)',
		// 	})
		// 	var postData = {
		// 		SETTB99ID: id,
		// 		SETTB109CD01: '',
		// 		limit: '1000',
		// 		page: '1',
		// 	}
		// 	var fdmoList
		// 	var url = 'set/settb109/selectPageList'
		// 	this.axios
		// 		.post(url, postData)
		// 		.then(res => {
		// 			// console.log(res)
		// 			setTimeout(() => {
		// 				loading.close()
		// 			}, 300)
		// 			if (res.data.code == 200) {
		// 				fdmoList = res.data.data
		// 				this.fdmaterList = fdmoList
		// 				this.fdpagingPageMaterial = res.data.count
		// 			} else {
		// 				this.$message({
		// 					message: res.data.message,
		// 					type: 'error',
		// 				})
		// 			}
		// 		})
		// 		.catch(() => {
		// 			loading.close()
		// 		})
		// },
		hsjhandleSizeChangeMaterial(val) {
			this.hsjListpageMaterial = 1
			this.hsjListlimitMaterial = val
			this.selectwlhxPageListFun()
		},
		// 点击页码
		hsjhandleCurrentChangeMaterial(val) {
			this.hsjListpageMaterial = val
			this.selectwlhxPageListFun()
		},
		materialTax(row) {
			this.hanshuijiaShow = true;
			this.taxName = row.ORMTB703CA00;
			this.taxProductId = row.ORMTB703CA02;
			this.selectwlhxPageListFun();
		},
		addTaxlist() {
			this.taxFlag = true;
			this.taxId = 1;
			this.tableDataTaxAdd = [{
				id: 1,
				ORMTB703CA00: "",
				ORMTB703CA01: "",
				ORMTB703CA02: "",
				ORMTB703CA04: 1,
			}]
		},
		addTax() {
			this.tableDataTaxAdd.push({
				id: this.taxId++,
				ORMTB703CA00: "",
				ORMTB703CA01: "",
				ORMTB703CA02: "",
				ORMTB703CA04: 1,
			});
		},
		addMaterial() {
			this.tableDataMaterialAdd.push({
				id: this.materialId++,
				SETTB419CA01: "",
				SETTB419CA02: "",
				SETTB419CA03: "",
				SETTB419CA04: "",
				SETTB419CA00: "",
				SETTB419CA06: "",
				SETTB419CA07: "",
				money: "",
			});
		},
		deleteTax(index) {
			this.$confirm('此操作将移除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.tableDataTaxAdd.splice(index, 1);
				this.$message.success('删除成功');
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		// 查询企业
		//额外优惠列表
		querycusListExtra() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				SETTB99ID: this.enterpriseTwoExtra,
				ORMTB410ID: this.cusQueryNameExtra,
				limit: this.pagesize2,
				page: this.page2,
			}
			var fdmoList
			var url = 'set/settb414/selectPageList'
			this.axios
				.post(url, postData)
				.then(res => {
					console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.tableDataExtra = res.data.data;
						this.count2 = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		querycusListMetail() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var url = '/set/settb419/list'
			this.axios
				.post(url, { page: this.page3, limit: this.pagesize3 })
				.then(res => {
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.count4 = res.data.count;
						this.tableDataMaterial = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		// 含税价列表
		querycusListTax() {
			this.ykhsjChangJiaFun();
		},
		dgwlyhFun(e) {
			console.log(e)
			this.dgwlyh = e
		},
		addNewRow() {
			this.tableDatayh.push({
				id: this.nextId++,
				SETTB414CA00: '',
				SETTB414CA01: '',
				SETTB414CA02: '',
				SETTB414CA03: '',
				SETTB414CA04: '',
				SETTB414CA05: '',
				SETTB414CA07: 1,
				SETTB414CA08: '',
				djkj: '',
				zcyh: '',
				zczk: ''
			});
		},
		deleteRow(index) {
			this.$confirm('此操作将移除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.tableDatayh.splice(index, 1);
				this.$message.success('删除成功');
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		pageMaterialList() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				SETTB109CA03: this.categoryMaterial, //物料类别
				SETTB109CA00: this.nameMaterial, //物料名称
				// SETTB109CD01: this.cjmsgobj.SETTB414CA01, //一级企业id
				SETTB99ID: this.productId, //二级企业ID
				ORMTB410ID: this.nameId,
				// ORMTB401CA01: this.materiaShowZJ, //企业是绑定还是自建
				page: this.pageMaterial,
				limit: this.limitMaterial,
			}
			this.materList = []
			var moList
			var url = '/set/settb109/selectPageListByCo'
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						moList = res.data.data

						this.materList = moList
						this.pagingPageMaterial = res.data.count
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		handleSizeChangeMaterial(val) {
			this.pageMaterial = 1
			this.limitMaterial = val
			this.pageMaterialList()
		},
		// 点击页码
		handleCurrentChangeMaterial(val) {
			this.pageMaterial = val
			this.pageMaterialList()
		},
		//用户单个物料优惠调控
		selectuserByPer() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				ORMTB410ID: this.nameId,
				SETTB109ID: this.MaterialModify109ID, //物料ID
			}
			var url = '/set/settb109/selectByPer'
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						console.log(res)

						if (res.data.data) {
							this.userName = this.nameTitle;
							this.individualDiscount = res.data.data.scyh;
							this.currentPrice = res.data.data.dqjg;
							// this.floatingAmount = 0 //浮动金额
							// this.floatingType = '1' //浮动类型-上浮/下调
							// this.floatingAmount = res.data.data.data.SETTB418CA07 //浮动金额
							// this.floatingType = JSON.stringify(res.data.data.data.SETTB418CA06) //浮动类型-上浮/下调
						} else {
							// this.floatingAmount = 0 //浮动金额
							// this.floatingType = '1' //浮动类型-上浮/下调
						}
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'success'
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},

		preservationDiscountModify() {
			if (this.floatingType === '') return this.$message.error('请选择浮动类型')
			if (this.floatingAmount == undefined)
				return this.$message.error('请输入浮动金额')

			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				// SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
				ORMTB410ID: this.nameId,
				SETTB109ID: this.MaterialModify109ID, //物料ID
				SETTB418CA06: this.floatingType, //上浮-下浮
				SETTB418CA07: this.floatingAmount, //浮动金额
				SETTB109CA01: this.currentPrice,
				newprice:this.adjustedPrice
			}
			var url = '/set/settb109/updateByPer'
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.discountShow = false
						this.$message({
							message: res.data.message,
							type: 'success',
						})
						this.pageMaterialList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},
		MaterialQuery() {
			this.pageMaterial = 1
			this.pageMaterialList()
		},
		handleMaterialTypeFilter(filters) {
			const values = filters['SETTB206CA01']
			this.categoryMaterial = values && values.length ? values[0] : ''
			this.pageMaterial = 1
			this.pageMaterialList()
		},
		DiscountModify(item) {
			this.discountShow = true
			// this.queryMaterialTypeLsit('')
			this.MaterialModify109ID = item.SETTB109ID //物料ID
			this.enterNameMaterialModify = item.SETTB99CA00 //企业名称
			this.nameMaterialModify = item.SETTB109CA00 //物料名称
			this.floatingType = '';
			this.floatingAmount = 0;
			this.adjustedPrice = '';
			this.selectuserByPer();
		},
		//查询物料信息
		queryMaterialTypeLsit() {
			// console.log(type)
			// if (type === 0) {
			// 	this.materialTypeList = [{
			// 		SETTB206CA00: "",
			// 		SETTB206CA01: "全部"
			// 	}];
			// }
			// else {
			// 	this.materialTypeList = []
			// }
			this.materialTypeList = [
				{
					SETTB206CA00: '',
					SETTB206CA01: '全部',
				},
			]
			var url = '/set/settb109/selectSETTB206CA01'
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					var data = res.data.data
					this.materialTypeList = [...this.materialTypeList, ...data]
					// if (type === 0) {
					// 	this.materialTypeList = [...this.materialTypeList, ...data];
					// } else {
					// 	this.materialTypeList = data
					// }
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		slmsgClick(row) {
			if (!row.SETTB414CA00) {
				this.$message({
					message: '请先选择客户',
					type: 'warning',
				})
				return
			}
			if (!row.SETTB414CA02) {
				this.$message({
					message: '请先选择企业',
					type: 'warning',
				})
				return
			}
			this.materShow = true
			this.cjmsgobj = row
			this.nameId = row.SETTB414CA00;
			this.nameTitle = row.SETTB414CA08;
			this.productId = row.SETTB414CA01;
			this.queryMaterialTypeLsit()
			this.pageMaterialList();
		},
		hasEmptyPropertyValue(arr) {
			for (const obj of arr) {
				for (const key in obj) {
					if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
						return true; // 找到空值属性，返回true
					}
				}
			}
			return false; // 未找到空值属性，返回false
		},
		//提交客户优惠信息
		khyhserve() {
			if (this.tableDatayh.length == 0) {
				this.$message({
					message: '请添加数据',
					type: 'warning',
				})
				return
			} else {
				if (this.hasEmptyPropertyValue(this.tableDatayh)) {
					this.$message({
						message: '请填写完整的数据',
						type: 'warning',
					})
					return
				}
			}
			if (this.editFlag) {//添加
				var url = '/set/settb414/save'
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)',
				})
				var postData = {
					list: this.tableDatayh,
				}
				this.axios
					.post(url, postData)
					.then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.querycusListExtra();
							this.discountsFlag = false;
						} else {
							this.$message({
								message: res.data.message,
								type: 'error',
							})
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					})
					.catch(() => {
						loading.close()
					})
			} else {//修改
				this.axios
					.post('set/settb414/update', this.tableDatayh[0])
					.then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.querycusListExtra();
							this.discountsFlag = false;
						} else {
							this.$message({
								message: res.data.message,
								type: 'error',
							})
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					})
					.catch(() => {
						loading.close()
					})
			}

		},
		khyhqx() {
			// this.$refs.multipleTable.clearSelection()
			this.discountsFlag = false
			// this.multipleSelection = []
		},
		// 额外添加优惠
		addDiscounts() {
			this.discountsFlag = true;
			this.editFlag = true;
			this.nextId = 1;
			this.tableDatayh = [
				{
					id: 1,
					SETTB414CA00: '',
					SETTB414CA01: '',
					SETTB414CA02: '',
					SETTB414CA03: '',
					SETTB414CA04: '',
					SETTB414CA05: '',
					SETTB414CA07: 1,
					SETTB414CA08: '',
					djkj: '',
					zcyh: '',
					zczk: ''
				}
			]
		},
		// 切换tab
		selectTab(index) {
			this.tabIndex = index;
			if (this.tabIndex == 1) {
				this.enterpriseTwo = '';
				this.tableDataGradePre = [];
				this.queryGradePreLsit();
			} else if (this.tabIndex == 2) {
				this.enterpriseTwoExtra = '';
				this.cusQueryNameExtra = '';
				this.tableDataExtra = [];
				this.querycusListExtra();
			} else if (this.tabIndex == 3) {
				this.taxObj = {
					SETTB99ID: '',
					ORMTB410ID: '',
				}
				this.tableDataTax = [];
				this.querycusListTax();
			} else if (this.tabIndex == 4) {
				this.tableDataMaterial = [];
				this.querycusListMetail();
			}
		},
		// 获取等级优惠
		getGradePre() {
			var url = "/set/settb400/getSettb400List"
			var postData = {
				ORMTB410ID: this.rowkhId,
			}
		},
		// 提交等级优惠
		submissionGradePre() {
			var url = "/set/settb400/updateSettb400List"
			var settb400List = []
			this.tableDataGradePre.forEach((resitme) => {
				resitme.settb400List.forEach((itme) => {
					// itme.SETTB400ID = itme.SETTB400ID;
					// itme.djkjca06 = itme.djkj;
					// itme.zczkca06 = itme.zczk;
					// itme.zcyhca06 = itme.zcyh;
					settb400List.push(itme)
				})
			})
			var postData = {
				settb400List: settb400List,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.queryGradePreLsit()
					this.$message({
						message: '保存成功',
						type: 'success'
					});
					this.yhPreferentialShow = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		// 重置
		ResetGradePre() {
			this.tableDataGradePre.forEach((resitme) => {
				resitme.settb400List.forEach((itme) => {
					itme.djkj = itme.djkjOld;
					itme.zczk = itme.zczkOld;
					itme.zcyh = itme.zcyhOld;
				})
			})
		},
		submisyhsionGradePre() {
			this.yhPreferentialShow = true
			var url = "/set/settb400/confirm"
			var settb400List = []
			this.tableDatayhGradePre = []
			this.tableDataGradePre.forEach((resitme) => {
				resitme.settb400List.forEach((itme) => {
					// itme.SETTB400ID = itme.SETTB400ID;
					// itme.djkjca06 = itme.djkj;
					// itme.zczkca06 = itme.zczk;
					// itme.zcyhca06 = itme.zcyh;
					settb400List.push(itme)
				})
			})
			var postData = {
				settb400List: settb400List,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				console.log(res)
				if (res.data.code == 200) {
					this.tableDatayhGradePre = res.data.data;
					this.tableDatayhGradePre.forEach((resitme) => {
						resitme.forEach((itme) => {
							itme.djkjOld = itme.djkj;
							itme.zczkOld = itme.zczk;
							itme.zcyhOld = itme.zcyh;
						})
					})
					// this.$message({
					// 	message: '提交成功',
					// 	type: 'success'
					// });
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		init() {
			this.cusQueryName = this.historyInfo.cusQueryName
			this.currentPage = this.historyInfo.currentPage
			this.page = this.historyInfo.page
			this.pagesize = this.historyInfo.pagesize
			this.cusStatus = this.historyInfo.cusStatus
		},
			resetCustomerQuery() {
				this.cusQueryName = '';
				this.currentPage = 1;
				this.page = 1;
				this.querycusList();
			},
			getCustomerInitial(name) {
				if (!name) return '客';
				const value = String(name).trim();
				return value ? value.charAt(0) : '客';
			},
		querycusList() {//等级优惠记录
			this.tableData = []
			var url = '/orm/ormtb410/selectPageList'
			var postData = {
				ORMTB400ID: this.uobj.ormtb400.ORMTB400ID,
				ORMTB410CA00: this.cusQueryName, //客户名称
				page: this.page,
				limit: this.pagesize,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data
						this.count = res.data.count
					}
					if (this.tableData.length > 0) {
						setTimeout(() => {
							loading.close()
						}, 300)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},
		tableDetilsClick() {
			// this.queryEnterpriseTwoLsit()
			this.levelmangShow = true;
			this.tabIndex = 1;
			this.enterpriseTwo = '';
			this.tableDataGradePre = [];
			this.queryGradePreLsit()
		},
		// 等级优惠列表
		queryGradePreLsit() {
			this.tableDataGradePre = []
			var url = "/set/settb400/selectSettb400ByCA03"
			var postData = {
				ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级代码ID
				ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
				SETTB99ID: this.enterpriseTwo,//二级企业ID
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
				customClass: 'custom-loading-mask'
			});
			this.$nextTick(() => {
				const mask = document.querySelector('.el-loading-mask');
				if (mask) {
					mask.style.zIndex = '10000';
				}
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataGradePre = res.data.data;
					this.tableDataGradePre.forEach((resitme) => {
						resitme.settb400List.forEach((itme) => {
							itme.djkjOld = itme.djkj;
							itme.zczkOld = itme.zczk;
							itme.zcyhOld = itme.zcyh;
						})
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		queryEnterpriseTwoLsit() {
			this.enterpriseTwoOptionList = [{
				SETTB99ID: "",
				SETTB99CA00: "全部",
			}]
			var url = "/set/settb100/selectSettb100ByCa02"
			var postData = {
				ORMTB400ID: this.uobj.ormtb400.ORMTB400ID,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.enterpriseTwoOptionList = [...this.enterpriseTwoOptionList, ...res.data.data];
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange(val) {
			this.pagesize = val
			this.page = 1
			this.querycusList()
		},
		handleCurrentChange(val) {
			this.page = val
			this.querycusList()
		},
		handleSizeChange2(val) {
			this.pagesize2 = val
			this.page2 = 1
			this.querycusListExtra()
		},
		handleCurrentChange2(val) {
			this.page2 = val
			this.querycusListExtra()
		},
		handleSizeChange3(val) {
			this.pagesize3 = val
			this.page3 = 1
			this.querycusListTax()
		},
		handleCurrentChange3(val) {
			this.page3 = val
			this.querycusListTax()
		},
		handleSizeChange4() {
			this.pagesize4 = val
			this.page4 = 1
			this.querycusListMetail()
		},
		handleCurrentChange4(val) {
			this.page4 = val
			this.querycusListMetail()
		},
	}
}
</script>
<style scoped>
	::v-deep .preferential-setting-dialog {
		border-radius: 20px;
		overflow: hidden;
		background: linear-gradient(180deg, #f6f9fe 0%, #ffffff 18%, #ffffff 100%);
		box-shadow: 0 22px 60px rgba(33, 61, 99, 0.18);
	}

	::v-deep .preferential-setting-dialog .el-dialog__header {
		padding: 18px 24px 12px;
		border-bottom: 1px solid #e7eef7;
		background: linear-gradient(135deg, #ffffff, #f3f8ff);
	}

	::v-deep .preferential-setting-dialog .el-dialog__title {
		font-size: 18px;
		font-weight: 700;
		color: #25364b;
	}

	::v-deep .preferential-setting-dialog .el-dialog__headerbtn {
		top: 18px;
		right: 18px;
	}

	::v-deep .preferential-setting-dialog .el-dialog__body {
		padding: 18px 22px 22px;
		background: #fff;
	}

	.preferential-setting-body {
		padding: 2px 2px 0;
	}

	.preferential-tabs {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		margin-bottom: 16px;
		padding: 12px;
		border: 1px solid #e5edf6;
		border-radius: 16px;
		background: linear-gradient(135deg, #f8fbff, #f3f8ff);
	}

	.preferential-tabs .levelmang_btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 112px;
		height: 38px;
		padding: 0 18px;
		font-size: 14px;
		font-weight: 600;
		color: #56657a;
		border: 1px solid #dbe5ef;
		border-radius: 999px;
		background: #fff;
		transition: all 0.18s ease;
	}

	.preferential-tabs .levelmang_btn:hover {
		color: #2470be;
		border-color: rgba(64, 158, 255, 0.38);
		background: #edf6ff;
	}

	.preferential-tabs .levelmang-title-active {
		color: #fff !important;
		border-color: transparent !important;
		background: linear-gradient(135deg, #2f89f4, #46b5ff) !important;
		box-shadow: 0 10px 20px rgba(64, 158, 255, 0.26);
	}

	.preferential-setting-body .public_criteriaRange {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 12px;
		margin-bottom: 14px;
		padding: 14px;
		border: 1px solid #e7eef7;
		border-radius: 16px;
		background: linear-gradient(135deg, #fbfdff, #f5f9ff);
	}

	.preferential-setting-body .public_oparetionBlock_Menu {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.preferential-setting-body .public_lbSty {
		width: auto;
		margin: 0;
		font-size: 13px;
		font-weight: 600;
		color: #56657a;
		white-space: nowrap;
	}

	.preferential-setting-body .public_optionSty {
		min-width: 220px;
	}

	.preferential-setting-body .public_saleWater_chaxun {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 36px;
		padding: 0 18px;
		font-size: 13px;
		font-weight: 600;
		border-radius: 999px;
		box-shadow: 0 8px 18px rgba(64, 158, 255, 0.18);
	}

	.preferential-setting-body .public_saleWater_xinzeng {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 36px;
		padding: 0 18px;
		font-size: 13px;
		font-weight: 600;
		border-radius: 999px;
		background: var(--fszs-warning) !important;
		border-color: var(--fszs-warning) !important;
		box-shadow: 0 8px 18px rgba(253, 183, 37, 0.28);
		margin-top: 2px;
	}

	.preferential-setting-body .levelmang-table {
		margin: 0;
		padding: 0;
		list-style: none;
		border: 1px solid #e6edf7;
		border-radius: 18px;
		overflow: hidden;
		background: #fff;
		box-shadow: 0 12px 32px rgba(35, 69, 113, 0.08);
	}

	.preferential-setting-body .levelmang-table-head {
		display: grid;
		grid-template-columns: 1.3fr 1fr 1fr 1fr 1fr;
		gap: 0;
		align-items: center;
		padding: 14px 16px;
		font-size: 13px;
		font-weight: 700;
		color: #3a4a5c;
		background: linear-gradient(135deg, #edf5ff, #f8fbff);
		border-bottom: 1px solid #dfe9f4;
	}

	.preferential-setting-body .levelmang-table-li {
		display: grid;
		grid-template-columns: 1.3fr 4fr;
		align-items: stretch;
		border-bottom: 1px solid #edf2f7;
	}

	.preferential-setting-body .levelmang-table-li:last-child {
		border-bottom: 0;
	}

	.preferential-setting-body .levelmang-table-CQ,
	.preferential-setting-body .levelmang-table-JB,
	.preferential-setting-body .levelmang-table-KJ,
	.preferential-setting-body .levelmang-table-ZK,
	.preferential-setting-body .levelmang-table-YH {
		display: flex;
		align-items: center;
		box-sizing: border-box;
		min-height: 54px;
		padding: 12px 14px;
		font-size: 13px;
		color: #314156;
		border-right: 1px solid #edf2f7;
	}

	.preferential-setting-body .levelmang-table-head > div:last-child,
	.preferential-setting-body .levelmang-table-li-tab-li > div:last-child {
		border-right: 0;
	}

	.preferential-setting-body .levelmang-table-CQ {
		font-weight: 600;
		background: #fbfdff;
	}

	.preferential-setting-body .levelmang-table-CQ-list {
		justify-content: center;
		text-align: center;
		font-weight: 700;
		color: #24364b;
		background: linear-gradient(180deg, #f9fbff, #f3f8ff);
	}

	.preferential-setting-body .levelmang-table-li-tab {
		padding: 8px 0;
		background: #fff;
	}

	.preferential-setting-body .levelmang-table-li-tab-li {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr;
		align-items: stretch;
		margin: 0 12px 10px;
		overflow: hidden;
		border: 1px solid #e8eff8;
		border-radius: 14px;
		background: linear-gradient(180deg, #ffffff, #f9fcff);
		box-shadow: 0 8px 18px rgba(35, 69, 113, 0.04);
	}

	.preferential-setting-body .levelmang-table-li-tab-li:last-child {
		margin-bottom: 0;
	}

	.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-JB {
		font-weight: 700;
		color: #2f4054;
		background: #f7fbff;
	}

	.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-KJ,
	.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-ZK,
	.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-YH {
		justify-content: center;
		gap: 4px;
	}

	.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-ZK input,
	.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-YH input {
		width: 96px;
		height: 34px;
		padding: 0 10px;
		font-size: 13px;
		color: #25364b;
		border: 1px solid #d7e2ee;
		border-radius: 10px;
		background: #fff;
	}

	.preferential-setting-body .levelmang-table-head {
		grid-template-columns: minmax(170px, 1.25fr) minmax(80px, 0.55fr) minmax(132px, 0.9fr) minmax(112px, 0.72fr) minmax(112px, 0.72fr);
	}

	.preferential-setting-body .levelmang-table-li {
		grid-template-columns: minmax(170px, 1.25fr) minmax(436px, 2.89fr);
	}

	.preferential-setting-body .levelmang-table-li-tab-li {
		grid-template-columns: minmax(80px, 0.55fr) minmax(132px, 0.9fr) minmax(112px, 0.72fr) minmax(112px, 0.72fr);
	}

	.preferential-setting-body .levelmang-table-CQ,
	.preferential-setting-body .levelmang-table-JB,
	.preferential-setting-body .levelmang-table-KJ,
	.preferential-setting-body .levelmang-table-ZK,
	.preferential-setting-body .levelmang-table-YH {
		padding-left: 10px;
		padding-right: 10px;
	}

	.preferential-setting-body .public-chech-details >>> .el-input-number {
		width: 110px;
	}

	.preferential-setting-body .public-chech-details >>> .el-input-number__decrease,
	.preferential-setting-body .public-chech-details >>> .el-input-number__increase {
		display: none;
	}

	.preferential-setting-body .public-chech-details >>> .el-input__inner {
		height: 34px;
		padding-right: 8px;
		border-radius: 10px;
		text-align: center;
	}

	.preferential-setting-body .salesPreferentialDig-btn {
		display: flex;
		justify-content: center;
		gap: 36px;
		margin: 18px 0 4px;
	}

	.preferential-extra-body .salesPreferentialDig-btn {
		display: flex;
		justify-content: center;
		gap: 36px;
		padding-right: 0;
	}

	.preferential-setting-body .salesPreferentialDig-btn >>> .el-button {
		min-width: 96px;
		height: 36px;
		padding: 0 18px;
		border-radius: 999px;
	}

	.preferential-setting-body .customerManagementPC-table {
		margin-top: 0;
	}

	.preferential-setting-body .customerManagementPC-page {
		padding: 12px 0 0;
	}

	.preferential-setting-body .el-table {
		border-radius: 16px;
		overflow: hidden;
	}

	.preferential-setting-body .el-table th {
		font-size: 13px;
		color: #30445c;
	}

	.preferential-setting-body .el-table td {
		padding: 10px 0;
		font-size: 13px;
	}

	.preferential-setting-body .customerManagementPC-table-btn {
		gap: 8px;
		justify-content: flex-start;
	}

	.preferential-setting-body .public_icon_width {
		min-width: 72px;
		height: 32px;
		padding: 0 12px;
	}

	.preferential-setting-body .el-pagination {
		padding: 0;
	}


	.sales-preferential-page {
		padding-bottom: 10px;
	}

	.preferential-page-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 12px;
		margin-bottom: 10px;
		padding: 14px 18px;
		border: 1px solid #e6edf7;
		border-radius: 22px;
		background: linear-gradient(135deg, #ffffff 0%, #f4f8ff 100%);
		box-shadow: 0 16px 36px rgba(35, 69, 113, 0.08);
	}

	.preferential-page-title {
		font-size: 24px;
		font-weight: 800;
		color: #20324a;
	}

	.preferential-page-subtitle {
		margin-top: 4px;
		font-size: 13px;
		line-height: 1.6;
		color: #66778d;
	}

	.preferential-page-actions {
		display: flex;
		align-items: center;
		gap: 12px;
		flex-wrap: wrap;
	}

	.preferential-primary-action {
		height: 40px;
		padding: 0 20px;
		border: 0;
		border-radius: 999px;
		box-shadow: 0 10px 22px rgba(64, 158, 255, 0.22);
	}

	.preferential-primary-action i {
		margin-right: 4px;
	}

	.preferential-quick-panel {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 10px;
		margin-bottom: 10px;
	}

	.preferential-stat-card {
		padding: 12px 16px;
		border: 1px solid #e5edf6;
		border-radius: 18px;
		background: #fff;
		box-shadow: 0 10px 24px rgba(35, 69, 113, 0.06);
	}

	.preferential-stat-card-wide {
		background: linear-gradient(135deg, #f8fbff, #f2f8ff);
	}

	.preferential-stat-label {
		font-size: 12px;
		font-weight: 600;
		color: #6f7f95;
	}

	.preferential-stat-value {
		margin-top: 6px;
		font-size: 28px;
		font-weight: 800;
		line-height: 1;
		color: #1f3c5b;
	}

	.preferential-shortcuts {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		margin-top: 6px;
	}

	.preferential-shortcuts span {
		padding: 5px 10px;
		border-radius: 999px;
		background: #eef6ff;
		font-size: 12px;
		font-weight: 600;
		color: #2a71bf;
	}

	.preferential-filter-card {
		padding: 12px 16px;
		margin-bottom: 10px;
		border: 1px solid #e6edf7;
		border-radius: 20px;
		background: #fff;
		box-shadow: 0 12px 28px rgba(35, 69, 113, 0.08);
	}

	.preferential-filter-fields {
		margin-bottom: 0;
		padding: 0;
		border: 0;
		background: transparent;
	}

	.preferential-filter-item {
		flex: 1;
	}

	.preferential-filter-item .public_optionSty {
		min-width: 320px;
		max-width: 100%;
	}

	.preferential-filter-actions {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 8px;
		flex-wrap: wrap;
		margin-left: auto;
		padding-top: 8px;
		border-top: 1px dashed #e3ebf4;
	}

	.preferential-reset-btn,
	.preferential-query-btn {
		height: 36px;
		padding: 0 18px;
		border-radius: 999px;
	}

	.preferential-query-btn {
		box-shadow: 0 8px 18px rgba(64, 158, 255, 0.18);
	}

	.preferential-table-card {
		padding: 12px 16px 10px;
		margin-top: 0;
		border: 1px solid #e6edf7;
		border-radius: 22px;
		background: #fff;
		box-shadow: 0 16px 36px rgba(35, 69, 113, 0.08);
	}

	.preferential-table-toolbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 18px;
		margin-bottom: 10px;
		padding: 0 4px;
	}

	.preferential-table-toolbar > div:first-child {
		padding-left: 6px;
	}

	.preferential-section-title {
		margin-top: 6px;
		font-size: 18px;
		font-weight: 800;
		color: #20324a;
	}

	.preferential-section-subtitle {
		margin-top: 4px;
		font-size: 12px;
		color: #6b7b90;
	}

	.preferential-table-total {
		flex-shrink: 0;
		margin-right: 6px;
		padding: 8px 18px;
		border-radius: 999px;
		background: #f2f7ff;
		font-size: 13px;
		font-weight: 700;
		color: #2a71bf;
	}

	.preferential-main-table {
		border-radius: 16px;
		overflow: hidden;
	}

	.preferential-customer-cell {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.preferential-customer-avatar {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 auto;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: linear-gradient(135deg, #2f89f4, #46b5ff);
		font-size: 14px;
		font-weight: 700;
		color: #fff;
	}

	.preferential-customer-info {
		min-width: 0;
	}

	.preferential-customer-name {
		overflow: hidden;
		font-size: 14px;
		font-weight: 700;
		color: #26384d;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.preferential-customer-tip {
		margin-top: 4px;
		font-size: 12px;
		color: #7a899d;
	}

	.preferential-level-tag {
		display: inline-flex;
		align-items: center;
		padding: 6px 12px;
		border-radius: 999px;
		background: #eef7ff;
		font-size: 12px;
		font-weight: 600;
		color: #2a71bf;
	}

	.preferential-view-btn {
		min-width: 96px;
		height: 32px;
		padding: 0 14px;
		border-radius: 999px;
	}

	.preferential-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 34px 16px;
		color: #6f7f95;
	}

	.preferential-empty-title {
		font-size: 16px;
		font-weight: 700;
		color: #2b4058;
	}

	.preferential-empty-desc {
		margin-top: 8px;
		font-size: 12px;
		color: #7b8a9d;
	}

	.preferential-page-footer {
		padding-top: 14px;
		display: flex;
		justify-content: flex-end;
	}

	::v-deep .preferential-main-table th {
		font-size: 13px;
		color: #2f4054;
	}

	::v-deep .preferential-main-table td {
		padding: 12px 0;
		font-size: 13px;
	}

	::v-deep .preferential-main-table .cell {
		line-height: 1.4;
	}


	::v-deep .preferential-info-dialog,
	::v-deep .preferential-extra-dialog {
		border-radius: 20px;
		overflow: hidden;
		background: linear-gradient(180deg, #f6f9fe 0%, #ffffff 18%, #ffffff 100%);
		box-shadow: 0 22px 60px rgba(33, 61, 99, 0.18);
	}

	::v-deep .preferential-info-dialog .el-dialog__header,
	::v-deep .preferential-extra-dialog .el-dialog__header {
		padding: 18px 24px 12px;
		border-bottom: 1px solid #e7eef7;
		background: linear-gradient(135deg, #ffffff, #f3f8ff);
	}

	::v-deep .preferential-info-dialog .el-dialog__title,
	::v-deep .preferential-extra-dialog .el-dialog__title {
		font-size: 18px;
		font-weight: 700;
		color: #25364b;
	}

	::v-deep .preferential-info-dialog .el-dialog__headerbtn,
	::v-deep .preferential-extra-dialog .el-dialog__headerbtn {
		top: 18px;
		right: 18px;
	}

	::v-deep .preferential-info-dialog .el-dialog__body,
	::v-deep .preferential-extra-dialog .el-dialog__body {
		padding: 18px 22px 22px;
		background: #fff;
	}

	.preferential-info-body .levelmang-table-CQ-list {
		justify-content: flex-start;
		text-align: left;
	}

	.preferential-info-body .levelmang-table-li-tab-li .levelmang-table-KJ > div,
	.preferential-info-body .levelmang-table-li-tab-li .levelmang-table-ZK > div,
	.preferential-info-body .levelmang-table-li-tab-li .levelmang-table-YH > div {
		min-width: 72px;
		padding: 7px 10px;
		text-align: center;
		font-weight: 600;
		color: #2364a8;
		border-radius: 999px;
		background: #eef7ff;
	}

	.preferential-extra-body {
		padding: 0;
	}

	.preferential-extra-actions {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 14px;
		padding: 12px 14px;
		border: 1px solid #e7eef7;
		border-radius: 16px;
		background: linear-gradient(135deg, #fbfdff, #f5f9ff);
	}

	.preferential-extra-actions >>> .el-button {
		height: 36px;
		padding: 0 18px;
		font-weight: 600;
		border-radius: 999px;
		box-shadow: 0 8px 18px rgba(64, 158, 255, 0.18);
	}

	.preferential-extra-body >>> .el-table {
		border: 1px solid #e6edf7;
		border-radius: 16px;
		box-shadow: 0 12px 32px rgba(35, 69, 113, 0.08);
	}

	.preferential-extra-body >>> .el-table th {
		font-size: 13px;
		color: #30445c;
		background: linear-gradient(135deg, #edf5ff, #f8fbff) !important;
	}

	.preferential-extra-body >>> .el-table td {
		padding: 9px 0;
		font-size: 13px;
	}

	.preferential-extra-body >>> .el-input__inner,
	.preferential-extra-body >>> .el-select .el-input__inner {
		height: 34px;
		border-radius: 10px;
	}

	.preferential-extra-body >>> .el-input,
	.preferential-extra-body >>> .el-select {
		width: 100%;
	}

	.preferential-extra-body .public_icon_width {
		min-width: 72px;
		height: 32px;
		padding: 0 12px;
	}



	::v-deep .view-preferential-dialog {
		border-radius: 20px;
		overflow: hidden;
		background: linear-gradient(180deg, #f6f9fe 0%, #ffffff 16%, #ffffff 100%);
		box-shadow: 0 22px 60px rgba(33, 61, 99, 0.18);
	}

	::v-deep .view-preferential-dialog .el-dialog__header {
		padding: 18px 24px 12px;
		border-bottom: 1px solid #e7eef7;
		background: linear-gradient(135deg, #ffffff, #f3f8ff);
	}

	::v-deep .view-preferential-dialog .el-dialog__title {
		font-size: 18px;
		font-weight: 700;
		color: #25364b;
	}

	::v-deep .view-preferential-dialog .el-dialog__body {
		padding: 18px 22px 22px;
		background: #fff;
	}

	.view-preferential-body {
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.view-preferential-summary {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 14px;
		padding: 14px 16px;
		border: 1px solid #e6edf7;
		border-radius: 16px;
		background: linear-gradient(135deg, #fbfdff, #f5f9ff);
	}

	.view-preferential-title {
		font-size: 18px;
		font-weight: 800;
		color: #20324a;
	}

	.view-preferential-subtitle {
		margin-top: 6px;
		font-size: 12px;
		color: #6b7b90;
	}

	.view-preferential-count {
		min-width: 104px;
		padding: 10px 14px;
		text-align: center;
		border-radius: 14px;
		background: #fff;
		box-shadow: 0 8px 18px rgba(35, 69, 113, 0.06);
	}

	.view-preferential-count span {
		display: block;
		font-size: 12px;
		font-weight: 600;
		color: #6f7f95;
	}

	.view-preferential-count strong {
		display: block;
		margin-top: 4px;
		font-size: 24px;
		line-height: 1;
		color: #2364a8;
	}

	.view-preferential-filter {
		display: grid;
		grid-template-columns: minmax(240px, 1fr) minmax(240px, 1fr) auto;
		align-items: end;
		gap: 12px;
		padding: 14px 16px;
		border: 1px solid #e6edf7;
		border-radius: 16px;
		background: #fff;
		box-shadow: 0 10px 24px rgba(35, 69, 113, 0.06);
	}

	.view-filter-item {
		display: flex;
		align-items: center;
		gap: 8px;
		min-width: 0;
	}

	.view-filter-item label {
		flex: 0 0 auto;
		font-size: 13px;
		font-weight: 700;
		color: #56657a;
		white-space: nowrap;
	}

	.view-filter-select {
		flex: 1;
		min-width: 0;
	}

	.view-filter-select >>> .el-input__inner {
		height: 36px;
		border-radius: 10px;
	}

	.view-filter-actions {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 10px;
	}

	.view-reset-btn,
	.view-query-btn {
		height: 36px;
		padding: 0 18px;
		border-radius: 999px;
	}

	.view-query-btn {
		box-shadow: 0 8px 18px rgba(64, 158, 255, 0.18);
	}

	.view-preferential-table-card {
		padding: 16px;
		border: 1px solid #e6edf7;
		border-radius: 18px;
		background: #fff;
		box-shadow: 0 12px 30px rgba(35, 69, 113, 0.08);
	}

	.view-table-toolbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		margin-bottom: 12px;
	}

	.view-table-title {
		font-size: 17px;
		font-weight: 800;
		color: #20324a;
	}

	.view-table-subtitle {
		margin-top: 5px;
		font-size: 12px;
		color: #6b7b90;
	}

	.view-table-total {
		padding: 8px 14px;
		border-radius: 999px;
		background: #f2f7ff;
		font-size: 13px;
		font-weight: 700;
		color: #2a71bf;
	}

	.view-preferential-table {
		border: 1px solid #e6edf7;
		border-radius: 16px;
		overflow: hidden;
	}

	::v-deep .view-preferential-table th {
		font-size: 13px;
		color: #30445c;
		background: linear-gradient(135deg, #edf5ff, #f8fbff) !important;
	}

	::v-deep .view-preferential-table td {
		padding: 9px 0;
		font-size: 13px;
	}

	::v-deep .view-preferential-table .cell {
		line-height: 1.45;
	}

	.view-preferential-empty {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 30px 12px;
		color: #6f7f95;
	}

	.view-preferential-empty div {
		font-size: 15px;
		font-weight: 700;
		color: #2b4058;
	}

	.view-preferential-empty span {
		margin-top: 6px;
		font-size: 12px;
		color: #7b8a9d;
	}

	.view-preferential-pagination {
		display: flex;
		justify-content: flex-end;
		padding-top: 14px;
	}

	@media screen and (max-width: 1200px) {
		.preferential-page-header {
			align-items: stretch;
			flex-direction: column;
		}

		.preferential-page-actions {
			justify-content: flex-start;
		}

		.preferential-quick-panel {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.preferential-stat-card-wide {
			grid-column: 1 / -1;
		}

		.preferential-filter-item .public_optionSty {
			min-width: 240px;
		}
	}

	@media screen and (max-width: 768px) {
		.preferential-page-header,
		.preferential-filter-card,
		.preferential-table-card {
			padding: 14px;
			border-radius: 16px;
		}

		.preferential-page-title {
			font-size: 20px;
		}

		.preferential-quick-panel {
			grid-template-columns: 1fr;
			gap: 10px;
		}

		.preferential-filter-fields,
		.preferential-filter-item,
		.preferential-filter-item .public_optionSty,
		.preferential-filter-item >>> .el-select {
			width: 100%;
			min-width: 100%;
		}

		.preferential-filter-actions {
			align-items: stretch;
			justify-content: flex-start;
		}

		.preferential-reset-btn,
		.preferential-query-btn,
		.preferential-primary-action {
			width: 100%;
		}

		.preferential-table-toolbar {
			align-items: flex-start;
			flex-direction: column;
		}

		.preferential-table-total {
			width: 100%;
			box-sizing: border-box;
			text-align: center;
		}
	}

	@media screen and (max-width: 1400px) {
		::v-deep .preferential-setting-dialog .el-dialog__body {
			padding: 16px 18px 20px;
		}

		.preferential-setting-body .levelmang-table-head {
			grid-template-columns: minmax(150px, 1.05fr) minmax(76px, 0.55fr) minmax(126px, 0.9fr) minmax(106px, 0.72fr) minmax(106px, 0.72fr);
		}

		.preferential-setting-body .levelmang-table-li {
			grid-template-columns: minmax(150px, 1.05fr) minmax(414px, 2.89fr);
		}
	}

	@media screen and (max-width: 1200px) {
		::v-deep .preferential-setting-dialog {
			width: 92% !important;
		}

		.preferential-setting-body .public_criteriaRange {
			align-items: flex-start;
			justify-content: flex-start;
		}

		.preferential-setting-body .public_optionSty {
			min-width: 180px;
		}

		.preferential-setting-body .levelmang-table-head {
			font-size: 12px;
		}

		.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-ZK input,
		.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-YH input {
			width: 84px;
		}
	}

	@media screen and (max-width: 768px) {
		::v-deep .preferential-setting-dialog .el-dialog__header {
			padding: 14px 16px 10px;
		}

		::v-deep .preferential-setting-dialog .el-dialog__body {
			padding: 14px 14px 16px;
		}

		.preferential-tabs {
			padding: 10px;
		}

		.preferential-tabs .levelmang_btn {
			min-width: calc(50% - 5px);
		}

		.preferential-setting-body .public_criteriaRange {
			padding: 12px;
		}

		.preferential-setting-body .public_optionSty {
			width: 100%;
			min-width: 100%;
		}

		.preferential-setting-body .levelmang-table-head {
			display: none;
		}

		.preferential-setting-body .levelmang-table-li {
			grid-template-columns: 1fr;
		}

		.preferential-setting-body .levelmang-table-CQ {
			justify-content: flex-start;
			border-right: 0;
			border-bottom: 1px solid #edf2f7;
		}

		.preferential-setting-body .levelmang-table-li-tab-li {
			grid-template-columns: 1fr;
			margin: 0 10px 10px;
		}

		.preferential-setting-body .levelmang-table-li-tab-li > div {
			justify-content: flex-start;
			border-right: 0;
			border-bottom: 1px solid #edf2f7;
		}

		.preferential-setting-body .levelmang-table-li-tab-li > div:last-child {
			border-bottom: 0;
		}

		.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-ZK input,
		.preferential-setting-body .levelmang-table-li-tab-li .levelmang-table-YH input {
			width: 100%;
		}

		.preferential-setting-body .salesPreferentialDig-btn {
			flex-direction: column;
		}

		.preferential-setting-body .salesPreferentialDig-btn >>> .el-button {
			width: 100%;
		}
	}

/deep/.public_operatBtn {
	display: flex;
	justify-content: space-between;
}

.salesPreferentialDig-btn {
	text-align: center;
	margin: 30px 0 20px 0;
}

.customerManagementPC-table-btn {
	display: flex;
}

.levelmang_btn {
	cursor: pointer;
}
.systemCorporateAccount-wuliao-input>input {
	height: 40px;
	box-sizing: border-box;
	border: 1px solid #dcdfe6;
	border-radius: 5px;
	padding-left: 5px;
}
.num {
	color: #333;
	font-size: 18px;
}

.cJ-btn {
	margin-top: 20px;
}

.shouQuanChangJia-dialog .el-checkbox {
	margin-bottom: 15px;
}

/deep/ .num .el-input .el-input__inner {
	font-size: 18px !important;
}

::v-deep .addPointer {
	cursor: pointer;
}

::v-deep .success-row {
	background-color: #81d3f8 !important;
}
	.sales-preferential-page .customerManagementPC {
		background: transparent;
		color: var(--fszs-text);
	}

	.sales-preferential-page .pulbic_table_container {
		border: 1px solid rgba(220, 230, 242, 0.96);
		border-radius: var(--fszs-radius-lg);
		background: #ffffff;
		box-shadow: var(--fszs-shadow-sm);
		overflow: hidden;
	}

	.preferential-setting-body .customerManagementPC-table,
	.preferential-extra-body .pulbic_table_container,
	.public-chech .pulbic_table_container {
		padding: 14px 14px 0;
		border: 1px solid var(--fszs-border-soft);
		border-radius: 14px;
		background: #ffffff;
		box-shadow: none;
		overflow: hidden;
	}

	.preferential-setting-body .customerManagementPC-table::before,
	.preferential-extra-body .pulbic_table_container::before,
	.public-chech .pulbic_table_container::before {
		content: '';
		display: block;
		width: 34px;
		height: 3px;
		margin-bottom: 10px;
		border-radius: 999px;
		background: linear-gradient(90deg, var(--fszs-primary), rgba(23, 139, 255, 0.18));
	}

	.preferential-setting-body .customerManagementPC-page,
	.preferential-extra-body .customerManagementPC-page,
	.public-chech .pulbic_pagesize,
	.view-preferential-pagination {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		padding: 12px 50px 4px 0;
		margin-top: 8px;
		border-top: 1px solid var(--fszs-border-soft);
	}

	.preferential-setting-body .public_criteriaRange,
	.public-chech-details-tile {
		align-items: center;
		gap: 12px 16px;
		border-color: var(--fszs-border-soft);
		background: linear-gradient(180deg, #fbfdff 0%, #f7fbff 100%);
	}

	.public-chech-details-tile {
		display: flex;
		flex-wrap: wrap;
		padding: 12px 14px;
		margin-bottom: 14px;
		border: 1px solid var(--fszs-border-soft);
		border-radius: 12px;
	}

	.public-chech-details-tile-pre,
	.public-chech-details-tile-q {
		color: var(--fszs-text-muted);
		font-weight: 500;
	}

	.public-chech-details-tile-pre-sel,
	.public-chech-details-tile-q-sel {
		min-width: 220px;
		max-width: 220px;
	}

	.public-chech-details-tile-pre-sel .el-select,
	.public-chech-details-tile-q-sel .el-select {
		width: 100%;
	}

	.preferential-setting-body .public_optionSty,
	.public-chech-details-tile .public_optionSty {
		min-width: 220px;
	}

	.systemCorporateAccount-dialog {
		padding: 4px 8px 0;
	}

	.systemCorporateAccount-dialog-li,
	.level-systemCorporateAccount-dialog-li {
		display: grid;
		grid-template-columns: 130px minmax(0, 1fr);
		align-items: center;
		gap: 12px;
		width: auto;
		padding: 10px 12px;
		border: 1px solid var(--fszs-border-soft);
		border-radius: 10px;
		background: #f8fbff;
		box-sizing: border-box;
	}

	.level-systemCorporateAccount-dialog-li {
		margin-bottom: 12px;
	}

	.systemCorporateAccount-dialog-li + .systemCorporateAccount-dialog-li {
		margin-top: 12px;
	}

	.SCADL-text {
		height: auto;
		line-height: 32px;
		font-size: 14px;
		color: var(--fszs-text-muted);
		font-weight: 500;
		text-align: right;
	}

	.SCADL-text span {
		color: var(--fszs-danger);
	}

	.SCADL-input {
		min-width: 0;
	}

	.SCADL-input input,
	.SCADL-input ::v-deep .el-input__inner,
	.SCADL-input ::v-deep .el-textarea__inner {
		height: 34px;
		line-height: 34px;
		padding: 0 10px;
		border: 1px solid var(--fszs-border);
		border-radius: 8px;
		background: #ffffff;
		font-size: 14px;
		color: var(--fszs-text);
		box-sizing: border-box;
	}

	.SCADL-input input:focus,
	.SCADL-input ::v-deep .el-input__inner:focus,
	.SCADL-input ::v-deep .el-textarea__inner:focus {
		border-color: var(--fszs-primary);
		box-shadow: var(--fszs-focus);
		outline: none;
	}

	.systemCorporateAccount-dialog-btn,
	.salesPreferentialDig-btn {
		display: flex;
		justify-content: center;
		gap: 12px;
		margin: 22px 0 6px;
	}

	.systemCorporateAccount-dialog-btn ::v-deep .el-button,
	.salesPreferentialDig-btn ::v-deep .el-button {
		min-width: 92px;
		height: 36px;
		padding: 0 18px;
		border-radius: 999px;
	}

	.preferential-setting-body .levelmang-table,
	.preferential-info-body .levelmang-table {
		max-height: 58vh;
		overflow: auto;
	}

	.preferential-setting-body .levelmang-table-head,
	.preferential-info-body .levelmang-table-head {
		position: sticky;
		top: 0;
		z-index: 3;
	}

	.preferential-setting-body .levelmang-table-li-tab-li:hover,
	.preferential-info-body .levelmang-table-li-tab-li:hover {
		border-color: rgba(23, 139, 255, 0.22);
		box-shadow: 0 8px 18px rgba(23, 139, 255, 0.08);
	}

	.preferential-extra-body ::v-deep .el-table .cell,
	.preferential-setting-body ::v-deep .el-table .cell,
	.public-chech ::v-deep .el-table .cell {
		line-height: 1.45;
	}

	.preferential-extra-body ::v-deep .el-table th,
	.preferential-setting-body ::v-deep .el-table th,
	.public-chech ::v-deep .el-table th {
		background: linear-gradient(180deg, #f7fbff 0%, #eef6ff 100%) !important;
		color: var(--fszs-text-strong) !important;
		font-weight: 600;
	}

	.preferential-extra-body .public_icon_width,
	.preferential-setting-body .public_icon_width,
	.public-chech .public_icon_width {
		min-width: 72px;
		height: 30px;
		padding: 0 12px;
		border-radius: 7px;
	}

	.preferential-extra-body .customerManagementPC-table-btn,
	.preferential-setting-body .customerManagementPC-table-btn,
	.public-chech .customerManagementPC-table-btn {
		display: flex;
		justify-content: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.view-preferential-filter {
		border-color: var(--fszs-border-soft);
		background: linear-gradient(180deg, #fbfdff 0%, #f7fbff 100%);
	}

	.view-preferential-table-card {
		border-color: var(--fszs-border-soft);
		box-shadow: var(--fszs-shadow-sm);
	}

	.view-preferential-table-card ::v-deep .el-table__body-wrapper {
		max-height: 520px;
		overflow: auto;
	}

	@media screen and (max-width: 1366px) {
		.preferential-setting-body .levelmang-table,
		.preferential-info-body .levelmang-table {
			max-height: 52vh;
		}

		.systemCorporateAccount-dialog-li,
		.level-systemCorporateAccount-dialog-li {
			grid-template-columns: 112px minmax(0, 1fr);
		}
	}

	@media screen and (max-width: 768px) {
		.systemCorporateAccount-dialog-li,
		.level-systemCorporateAccount-dialog-li {
			grid-template-columns: 1fr;
			gap: 6px;
		}

		.SCADL-text {
			text-align: left;
		}

		.public-chech-details-tile-pre-sel,
		.public-chech-details-tile-q-sel,
		.preferential-setting-body .public_optionSty,
		.public-chech-details-tile .public_optionSty {
			min-width: 100%;
			width: 100%;
		}
	}

</style>
<style>
.djkj-input-positive .el-input__inner {
	color: #b3261e;
	font-weight: 600;
}

.djkj-input-negative .el-input__inner {
	color: #0a6b3c;
	font-weight: 600;
}

.sales-preferential-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-preferential-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-preferential-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-preferential-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-preferential-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>